webpackJsonp([1],{

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(548),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(542),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 143:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 5.134L4.866 9l7.057-7.057L10.98 1 4.866 7.115 1.994 4.242 1 5.134z" fill="#2CEEA8" stroke="#2CEEA8"/></svg>'};

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logEntry;

function logEntry(message, color) {

    var dictObject = {
        message: message,
        color: color
    };

    return dictObject;
}

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z" fill="#F95F5F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.9 8.414L15.485 7l-3.535 3.536L8.414 7 7 8.414l3.536 3.536L7 15.485 8.414 16.9l3.536-3.536 3.535 3.535 1.415-1.414-3.536-3.535 3.535-3.536z" fill="#fff"/></svg>'};

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z" fill="#CACACA"/><path d="M16.267 9.778H15.2V8.667c0-1.841-1.433-3.334-3.2-3.334-1.767 0-3.2 1.493-3.2 3.334v1.11H7.733c-.589 0-1.066.498-1.066 1.112v6.666c0 .614.477 1.112 1.066 1.112h8.534c.589 0 1.066-.498 1.066-1.112V10.89c0-.614-.477-1.111-1.066-1.111zM12 15.888c-.884 0-1.6-.745-1.6-1.666 0-.92.716-1.666 1.6-1.666.884 0 1.6.746 1.6 1.666 0 .92-.716 1.667-1.6 1.667zm2.133-6.11H9.867V8.667c0-1.228.955-2.223 2.133-2.223s2.133.995 2.133 2.223v1.11z" fill="#fff"/></svg>'};

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.667 6.667a1.333 1.333 0 0 1 0 2.666H9.333v5.334a1.333 1.333 0 0 1-2.666 0V9.333H1.333a1.333 1.333 0 1 1 0-2.666h5.334V1.333a1.333 1.333 0 1 1 2.666 0v5.334h5.334z" fill="#F0532C"/></svg>'};

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_app_scss__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_scss_app_scss__);


// import { store } from './store';





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a, {
    container: "body",
    duration: 2000,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    // store,
    template: '<App/>',
    data: function data() {
        return {
            Helpers: __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */]
        };
    },
    created: function created() {
        window.vue = this;
    },

    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_Resize__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_Resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_1_common_Resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_3_pages_Signup__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_3_pages_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_3_pages_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_3_pages_Delete__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_3_pages_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_3_pages_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_3_pages_Test__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_3_pages_Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_3_pages_Test__);
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex';





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        Resize: __WEBPACK_IMPORTED_MODULE_0__components_1_common_Resize___default.a,
        Signup: __WEBPACK_IMPORTED_MODULE_1__components_3_pages_Signup___default.a,
        Delete: __WEBPACK_IMPORTED_MODULE_2__components_3_pages_Delete___default.a,
        Test: __WEBPACK_IMPORTED_MODULE_3__components_3_pages_Test___default.a
    }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ErrorModal',
    props: {
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            documentScrollPosition: null
        };
    },

    methods: {
        dismissError: function dismissError() {
            this.$emit('dismissError');
        }
    },
    created: function created() {
        var _this = this;

        this.$once('hook:destroyed', function () {
            document.body.removeAttribute('style');
            window.scrollTo(0, Math.abs(_this.documentScrollPosition));
        });
    },
    mounted: function mounted() {
        this.documentScrollPosition = document.body.getBoundingClientRect().y;
        document.body.setAttribute('style', 'position:fixed; top:' + this.documentScrollPosition + 'px; overflow: hidden;');
    }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_check_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_error_check_svg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_error_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_error_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_lock_svg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_lock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_lock_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InputField',
    components: {
        checkIcon: __WEBPACK_IMPORTED_MODULE_0__assets_svg_check_svg___default.a,
        errorCheckIcon: __WEBPACK_IMPORTED_MODULE_1__assets_svg_error_check_svg___default.a,
        checkWhiteIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg___default.a,
        checkLockIcon: __WEBPACK_IMPORTED_MODULE_3__assets_svg_lock_svg___default.a
    },
    props: {
        mask: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false
        },
        value: {
            type: String,
            required: false,
            default: ''
        },
        errorMessage: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        autocomplete: {
            type: String,
            required: false
            // default: 'text'
        },
        autocapitalize: {
            type: String,
            required: false
            // default: 'on'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        errored: {
            type: Boolean,
            required: false,
            default: false
        },
        validated: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            inputValue: '',
            empty: true
        };
    },

    watch: {
        value: {
            immediate: true,
            handler: function handler(val) {

                this.empty = val.trim() == '';
                this.inputValue = val;
            }
        },
        inputValue: {
            immediate: true,
            handler: function handler(val) {
                this.$emit('input', val);
            }
        }
    }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_preloader_svg__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_preloader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_preloader_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Preloader',
    components: {
        PreloaderIcon: __WEBPACK_IMPORTED_MODULE_1__assets_svg_preloader_svg___default.a
    },
    data: function data() {
        return {
            preloaderInterval: null,
            preloaderTextIdx: 0,
            preloaderTextArray: ['Creating your account...', 'Still creating your account...', 'We’re working on it.<br> Give us a minute.', 'Maybe go get some coffee?<br> Or water? Tea sounds good too'],
            documentScrollPosition: null
        };
    },

    methods: {
        enter: function enter(el, done) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].from(el, 2, {
                autoAlpha: 0, onComplete: function onComplete() {
                    done();
                }
            });
        },
        leave: function leave(el, done) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].to(el, 2, {
                autoAlpha: 0, onComplete: function onComplete() {
                    done();
                }
            });
        },
        preloaderText: function preloaderText() {
            return this.preloaderTextArray[this.preloaderTextIdx];
        }
    },
    created: function created() {
        var _this = this;

        this.$once('hook:destroyed', function () {
            document.body.removeAttribute('style');
            window.scrollTo(0, Math.abs(_this.documentScrollPosition));
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.documentScrollPosition = document.body.getBoundingClientRect().y;
        document.body.setAttribute('style', 'position:fixed; top:' + this.documentScrollPosition + 'px; overflow: hidden;');

        this.preloaderInterval = setInterval(function () {
            if (_this2.preloaderTextIdx < 3) {
                _this2.preloaderTextIdx = _this2.preloaderTextIdx + 1;
            } else {
                _this2.preloaderTextIdx = 0;
            }
        }, 3000);
    }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


var defaultWidth = 375,
    defaultFont = 16,
    minWidth = 375,
    minHeight = 812,
    defaultHeight = 812;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Resize',
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize.bind(this));

        this.$root.$emit('onResize', { vW: this.vW, vH: this.vH });
        if (this.isMobile()) {
            document.documentElement.classList.add('mobile');
            document.documentElement.classList.remove('desktop');
        } else {
            document.documentElement.classList.remove('mobile');
            document.documentElement.classList.add('desktop');
        }
    },
    data: function data() {
        return {
            vW: window.innerWidth,
            vH: window.innerHeight
        };
    },


    computed: {
        fSize: function fSize() {
            var vW = this.vW;
            var vH = this.vH;
            return this.isMobile() ? 16 : 16 * Math.min(Math.max(minWidth, vW) / defaultWidth, Math.max(minHeight, vH) / defaultHeight);
        }
    },
    methods: {
        onResize: function onResize() {
            this.vW = window.innerWidth;
            this.vH = window.innerHeight;

            this.$root.$emit('onResize', { vW: this.vW, vH: this.vH });

            if (this.isMobile()) {
                document.documentElement.classList.add('mobile');
                document.documentElement.classList.remove('desktop');
            } else {
                document.documentElement.classList.remove('mobile');
                document.documentElement.classList.add('desktop');
            }
        },
        isMobile: function isMobile() {
            return this.$root.Helpers.isMobile();
        }
    }

});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step1_AccHolder',
    methods: {
        goNextStep: function goNextStep() {
            this.$emit('nextStep');
        }
    },
    mounted: function mounted() {
        amplitude.getInstance().logEvent('signup_page_master_loaded');
        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            button = _$refs.button;

        tl.from([title, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_error_check_svg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_error_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_error_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_check_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_check_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_check_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_lock_svg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_lock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_lock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_firebaseConfig__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_timers__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_timers__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var fb = __webpack_require__(60);

var tl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step2_MakeAcc',
    data: function data() {
        return {
            name: '',
            email: '',
            password: '',
            emailErrorMessage: '',
            invalidEmail: ''
        };
    },

    watch: {
        name: function name(val) {
            // console.log(val);
            var data = {
                field: 'full_name',
                new_value: val
            };
            amplitude.getInstance().logEvent('input_changed', data);
        },
        email: function email(val) {
            // console.log(val);
            var data = {
                field: 'email',
                new_value: val
            };
            amplitude.getInstance().logEvent('input_changed', data);
        }
    },
    components: {
        InputField: __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField___default.a,

        checkIcon: __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg___default.a,
        errorCheckIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_error_check_svg___default.a,
        checkWhiteIcon: __WEBPACK_IMPORTED_MODULE_3__assets_svg_check_white_svg___default.a,
        checkLockIcon: __WEBPACK_IMPORTED_MODULE_4__assets_svg_lock_svg___default.a
    },
    computed: {
        nameValid: function nameValid() {
            return this.name.length >= 2;
        },
        emailValid: function emailValid() {
            if (this.email == this.invalidEmail) {
                return false;
            }
            return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
            );
        },
        passwordValid: function passwordValid() {
            return this.password.length >= 6;
        }
    },
    methods: {
        isValid: function isValid() {

            return this.nameValid && this.emailValid && this.passwordValid;
        },
        persist: function persist() {
            localStorage.setItem('name', this.name);
            localStorage.setItem('email', this.email);
            localStorage.setItem('passwordLength', this.password.length);
            localStorage.setItem('accountCreated', true);
        },
        goNextStep: function goNextStep() {
            var _this = this;

            if (!this.isValid()) {
                return;
            }

            this.persist();

            this.$emit('showLoading');
            console.log('creating user...');

            __WEBPACK_IMPORTED_MODULE_6__tools_firebaseConfig__["auth"].createUserWithEmailAndPassword(this.email, this.password).then(function (credential) {

                console.log('user auth created!');
                console.log('credential:');
                console.log(credential);

                var uid = credential.user.uid;
                var email = credential.user.email;

                var userModel = {
                    'email': email,
                    'emergencyNumber': '911',
                    'name': _this.name,
                    'profileImageUrl': 'https://firebasestorage.googleapis.com/v0/b/ohana-4dd34.appspot.com/o/UserImages%2F88n3CkBsoiXdU8E5LYPi1s1tT6d2%2FprofilePicture?alt=media&token=a32567f2-9e2d-4e93-8ed1-d49a43f01859',
                    'uid': uid,
                    'signup_platform': 'web'
                };

                console.log('creating Database entry...');

                __WEBPACK_IMPORTED_MODULE_6__tools_firebaseConfig__["usersCollection"].child(uid).set(userModel).then(function () {
                    console.log('user created in DB!');
                    _this.$parent.currentName = _this.name;
                    _this.$parent.currentUid = uid;
                    _this.$parent.currentEmail = _this.email;
                    _this.$emit('dismissLoading');
                    _this.$emit('nextStep');
                }).catch(function (error) {
                    console.log('error creating user in DB:');
                    console.log(error);
                });

                // Update display name
                credential.user.updateProfile({
                    displayName: _this.name
                }).then(function () {
                    console.log('displayName updated');
                }).catch(function (error) {
                    console.log('error updating Profile:');
                    console.log(error);
                });

                // Send Amplitude User credential update
                var userProperties = {
                    email: email,
                    firebase_uid: uid,
                    name: _this.name,
                    sign_up_date: new Date()
                };

                amplitude.getInstance().setUserId(uid);
                amplitude.getInstance().setUserProperties(userProperties);

                // Facebook Pixel

                // Advanced
                fbq('init', '1147144752146644', {
                    em: email
                });

                // Standard
                fbq('track', 'CompleteRegistration');
            }).catch(function (error) {

                _this.$emit('dismissLoading');

                console.error('createUserWithEmailAndPassword error:');
                console.log(error);
                if (error.code == 'auth/email-already-in-use') {
                    _this.emailErrorMessage = error.message;
                    _this.invalidEmail = _this.email;
                } else {
                    console.log('UNACCOUNTED FOR CODE!:');
                    console.log(error.code);
                }
            });
        }
    },
    mounted: function mounted() {
        // console.log('two loaded');
        amplitude.getInstance().logEvent('signup_page_createaccount_loaded');

        // Persistance
        // if (localStorage.name) {
        //     this.name = localStorage.name;
        // }

        // if (localStorage.email) {
        //     this.email = localStorage.email;
        // }

        // if (localStorage.passwordLength) {
        //     this.password = "a".repeat(localStorage.passwordLength);
        // }

        // if (localStorage.accountCreated) {
        //     this.nextButtonText = 'Next';
        // }

        // Animations
        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            check = _$refs.check,
            form = _$refs.form,
            button = _$refs.button;

        tl.from([title, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(form, 1.2, { autoAlpha: 0, ease: Power2.easeOut }, "-=.8").from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_check_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_check_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_check_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_firebaseConfig__ = __webpack_require__(60);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step3_MobileNum',
    data: function data() {
        return {
            phoneNumber: ''
        };
    },

    watch: {
        phoneNumber: function phoneNumber(val) {
            // console.log(val);
            var data = {
                field: 'mobile_number',
                new_value: val
            };
            amplitude.getInstance().logEvent('input_changed', data);
        }
    },
    components: {
        checkWhiteIcon: __WEBPACK_IMPORTED_MODULE_0__assets_svg_check_white_svg___default.a,
        InputField: __WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField___default.a
    },
    computed: {
        numberValid: function numberValid() {
            return this.phoneNumber.length == 14;
        }
    },
    methods: {
        unmask: function unmask(val) {
            return val.replace(/\D+/g, '');
        },
        goNextStep: function goNextStep() {
            var _this = this;

            if (!this.numberValid) {
                return;
            }

            var unmaskedNumber = this.unmask(this.phoneNumber);
            var formattedNumber = '+1' + unmaskedNumber;

            this.$emit('showLoading');

            __WEBPACK_IMPORTED_MODULE_3__tools_firebaseConfig__["contactsCollection"].push().then(function (newRef) {

                var newContactModel = {
                    'country': 'US',
                    'id': newRef.key,
                    'name': _this.$parent.currentName,
                    'profileImageUrl': 'https://firebasestorage.googleapis.com/v0/b/ohana-4dd34.appspot.com/o/UserImages%2F88n3CkBsoiXdU8E5LYPi1s1tT6d2%2FprofilePicture?alt=media&token=a32567f2-9e2d-4e93-8ed1-d49a43f01859',
                    'phone': formattedNumber
                };

                newRef.set(newContactModel).then(function () {
                    console.log('new contact created with key:');
                    console.log(newRef.key);

                    // Add contact to user model
                    __WEBPACK_IMPORTED_MODULE_3__tools_firebaseConfig__["usersCollection"].child(_this.$parent.currentUid).child('contacts').child(newRef.key).set('0').then(function () {
                        console.log('alright updated user contacts model!');
                        _this.$emit('dismissLoading');
                        _this.$emit('nextStep');
                    }).catch(function (error) {
                        console.log('error updating the user model contacts:');
                        console.log(error);
                    });
                }).catch(function (error) {
                    console.log('error setting contact:');
                    console.log(error);
                });
            }).catch(function (error) {
                console.log('new contact push failed');
                console.log(error);
            });
        }
    },
    mounted: function mounted() {

        amplitude.getInstance().logEvent('signup_page_mobilenum_loaded');

        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            form = _$refs.form,
            button = _$refs.button;

        tl.from([title, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(form, 1.2, { autoAlpha: 0, ease: Power2.easeOut }, "-=.8").from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_firebaseConfig__ = __webpack_require__(60);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var tl = new __WEBPACK_IMPORTED_MODULE_4_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step4_AddContacts',
    data: function data() {
        return {
            contacts: [{
                name: '',
                phone: ''
            }]
        };
    },

    watch: {
        contacts: function contacts(val) {

            var data = {
                field: 'contacts',
                new_value: val
            };
            amplitude.getInstance().logEvent('input_changed', data);
        }
    },
    components: {
        InputField: __WEBPACK_IMPORTED_MODULE_1__components_1_common_InputField___default.a,
        checkWhiteIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg___default.a,
        plusIcon: __WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg___default.a
    },
    methods: {
        nameValid: function nameValid(name) {
            if (name.trim().length == 0) {
                return false;
            }
            return name.length >= 2;
        },
        numberValid: function numberValid(number) {
            return number.length == 14;
        },
        unmask: function unmask(val) {
            return val.replace(/\D+/g, '');
        },
        goNextStep: function goNextStep() {
            var _this = this;

            // Filters out invalid contacts
            var validContacts = this.contacts.filter(function (contact) {
                return _this.nameValid(contact.name) && _this.numberValid(contact.phone);
            });

            // If no valid contacts, skip
            if (validContacts.length == 0) {
                this.$emit('nextStep');
                return;
            }

            this.$emit('showLoading');

            var newContactIds = [];

            var contactPromises = validContacts.map(function (contact) {

                return __WEBPACK_IMPORTED_MODULE_5__tools_firebaseConfig__["contactsCollection"].push().then(function (newRef) {

                    var unmaskedNumber = _this.unmask(contact.phone);
                    var formattedNumber = '+1' + unmaskedNumber;

                    var newContactModel = {
                        'country': 'US',
                        'id': newRef.key,
                        'name': contact.name,
                        'profileImageUrl': 'https://firebasestorage.googleapis.com/v0/b/ohana-4dd34.appspot.com/o/UserImages%2F1QLXou9TplUYJA8IMJMtGckWelr1%2FprofilePicture?alt=media&token=8d19e65c-eb72-4633-ab16-4f99a0d10778',
                        'phone': formattedNumber
                    };

                    newContactIds.push(newRef.key);

                    return newRef.set(newContactModel).catch(function (error) {
                        console.log('error setting contact:');
                        console.log(error);
                    });
                });
            });

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(contactPromises).then(function (completeContacts) {

                console.log('all contacts set');
                console.log(newContactIds);

                var userModelPromises = newContactIds.map(function (newContactId) {

                    // Add contact to user model
                    return __WEBPACK_IMPORTED_MODULE_5__tools_firebaseConfig__["usersCollection"].child(_this.$parent.currentUid).child('contacts').child(newContactId).set('0').catch(function (error) {
                        console.log('error updating the user model:');
                        console.log(error);
                    });
                });

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(userModelPromises).then(function (completedUserModels) {

                    _this.$emit('dismissLoading');
                    _this.$emit('nextStep');
                });
            });
        },
        addContactForm: function addContactForm() {
            this.contacts.push({
                name: '',
                phone: ''
            });
        }
    },
    mounted: function mounted() {

        amplitude.getInstance().logEvent('signup_page_addcontacts_loaded');

        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            form = _$refs.form,
            button = _$refs.button,
            addButton = _$refs.addButton;

        tl.from([title, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(form, 1.2, { autoAlpha: 0, ease: Power2.easeOut }, "-=.8").from(addButton, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8").from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_apple_svg__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_apple_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_apple_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_paypal_svg__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_paypal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_paypal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_cards_svg__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_cards_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_svg_cards_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













// const stripe = Stripe('pk_test_Pry84GX42RNLAqFSbwNnSPfA');
var stripe = Stripe('pk_live_Y59xHOav57V3xRx2PlO0lRHP');

var elements = stripe.elements();
var card; // Have to declare here so I can use in goNextStep()

var axios = __webpack_require__(77);

var tl = new __WEBPACK_IMPORTED_MODULE_7_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step5_CreditCard',
    data: function data() {
        return {
            cardName: '',
            cardErrorMessage: '',
            cardComplete: false
        };
    },

    watch: {
        cardName: function cardName(val) {

            var data = {
                field: 'card_name',
                new_value: val
            };
            amplitude.getInstance().logEvent('input_changed', data);
        },
        cardErrorMessage: function cardErrorMessage(val) {

            var data = {
                error_message: val
            };
            amplitude.getInstance().logEvent('error_message_changed', data);
        },
        cardComplete: function cardComplete(val) {

            var data = {
                bool: val
            };
            amplitude.getInstance().logEvent('card_complete_bool', data);
        }
    },
    components: {
        InputField: __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField___default.a,
        checkIcon: __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_svg___default.a,
        checkWhiteIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_check_white_svg___default.a,
        plusIcon: __WEBPACK_IMPORTED_MODULE_3__assets_svg_plus_svg___default.a,
        appleIcon: __WEBPACK_IMPORTED_MODULE_4__assets_svg_apple_svg___default.a,
        paypalIcon: __WEBPACK_IMPORTED_MODULE_5__assets_svg_paypal_svg___default.a,
        cardsIcon: __WEBPACK_IMPORTED_MODULE_6__assets_svg_cards_svg___default.a
    },
    computed: {
        isValid: function isValid() {
            // card
            return this.nameValid(this.cardName) && this.cardComplete;
        }
    },
    methods: {
        weekFromNow: function weekFromNow() {
            var nowDate = new Date();
            // console.log(newDate);
            nowDate.setDate(nowDate.getDate() + 7);

            var dateOptions = { month: 'long', day: 'numeric' };
            var dateString = nowDate.toLocaleDateString('en-US', dateOptions);

            return dateString;
        },
        nameValid: function nameValid(name) {
            if (name.trim().length == 0) {
                return false;
            }
            return name.length >= 2;
        },
        goNextStep: function goNextStep() {
            var _this = this;

            if (!this.isValid) {
                return;
            }

            this.$emit('showLoading');

            var stripeTokenURL = 'https://old.ohanaisfamily.com/api/stripeSubscribe';

            var cardData = {
                name: this.cardName
            };

            stripe.createToken(card, cardData).then(function (result) {

                if (result.error) {
                    // Inform the customer that there was an error.
                    // var errorElement = document.getElementById('card-errors');
                    // errorElement.textContent = result.error.message;

                    console.log('error trying to create stripe token:');
                    console.log(result.error);

                    _this.$emit('dismissLoading');
                    _this.$emit('showError', result.error.message);
                } else {

                    // Send the token to your server.
                    // stripeTokenHandler(result.token);
                    console.log('success!');
                    console.log(result);
                    console.log('sending to backend...');

                    var body = {
                        token: result.token,
                        email: _this.$parent.currentEmail,
                        name: _this.cardName,
                        firebase_uid: _this.$parent.currentUid
                    };

                    axios.post(stripeTokenURL, body).then(function (response) {
                        console.log(response);
                        _this.$emit('dismissLoading');
                        _this.$emit('nextStep');

                        // Amplitude
                        amplitude.getInstance().logEvent('card_success');

                        // Facebook
                        fbq('track', 'StartTrial');
                    }).catch(function (error) {
                        console.log(error);
                        _this.$emit('dismissLoading');
                        _this.$emit('showError', error.message);

                        // Amplitude
                        var data = {
                            error: error
                        };
                        amplitude.getInstance().logEvent('card_error', data);
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        // Amplitude
        amplitude.getInstance().logEvent('signup_page_creditcard_loaded');

        // Facebook
        fbq('track', 'InitiateCheckout');

        window.scrollTo(0, 0);

        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            form = _$refs.form,
            button = _$refs.button,
            service = _$refs.service,
            payment = _$refs.payment;

        tl.from([title, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from([form, service, payment], 1.2, { autoAlpha: 0, ease: Power2.easeOut }, "-=.8").from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");

        var nameInput = document.getElementById("name");
        var nameStyle = window.getComputedStyle(nameInput, null);

        window.addEventListener('resize', function () {
            var nameStyle = window.getComputedStyle(nameInput, null);
            card.update({ style: { base: { fontSize: nameStyle.fontSize } } });
        });

        // Card element
        var style = {
            base: {
                // Add your base input styles here. For example:
                fontSize: nameStyle.fontSize,
                color: "#32325d",
                fontStyle: 'Noto Sans',
                fontWeight: '400',
                fontSmoothing: 'antialiased',
                '::placeholder': {
                    color: '#BCBCBC'
                }
            }
        };

        // var card = elements.create('card', {style: style});
        card = elements.create('card', { style: style });

        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');

        card.addEventListener('change', function (event) {

            var displayError = document.getElementById('card-errors');
            _this2.cardComplete = event.complete;

            if (event.error) {
                console.log('error!:', event);
                _this2.cardErrorMessage = event.error.message;
            } else {
                _this2.cardErrorMessage = '';
            }
        });
    },
    beforeDestroy: function beforeDestroy() {

        // Must explicitly destroy the card or else it'll blow up with errors
        card.destroy();
    }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_check_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step6_MakeNum',
    data: function data() {
        return {
            areaCode: ''
        };
    },

    watch: {
        areaCode: function areaCode(val) {

            var data = {
                field: 'area_code',
                new_value: val
            };
            amplitude.getInstance().logEvent('input_changed', data);
        }
    },
    components: {
        InputField: __WEBPACK_IMPORTED_MODULE_0__components_1_common_InputField___default.a,
        checkWhiteIcon: __WEBPACK_IMPORTED_MODULE_1__assets_svg_check_white_svg___default.a
    },
    computed: {
        areaCodeValid: function areaCodeValid() {
            return this.areaCode.length == 3;
        }
    },
    methods: {
        goNextStep: function goNextStep() {
            var _this = this;

            if (!this.areaCodeValid) {
                return;
            }

            this.$emit('showLoading');

            var axios = __webpack_require__(77);
            var buyNumURL = "https://old.ohanaisfamily.com/api/buyNumber";

            var body = {
                'areaCode': this.areaCode,
                'uid': this.$parent.currentUid
            };

            axios.post(buyNumURL, body).then(function (response) {
                console.log('success num buy');
                console.log(response);

                _this.$parent.ohanaNumber = response.data.phoneNumber;
                _this.$emit('dismissLoading');
                _this.$emit('nextStep');
            }).catch(function (error) {
                console.log('error num buy');
                console.log(error);
                // this.$emit('dismissLoading');
                // this.$emit('showError', error.message);
            });
        }
    },
    mounted: function mounted() {

        amplitude.getInstance().logEvent('signup_page_makenum_loaded');

        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            form = _$refs.form,
            button = _$refs.button;

        tl.from([title, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(form, 1.2, { autoAlpha: 0, ease: Power2.easeOut }, "-=.8").from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step7_OhanaNum',
    data: function data() {
        return {
            ohanaNumber: ''
        };
    },

    methods: {
        goNextStep: function goNextStep() {
            this.$emit('nextStep');
        },
        formatPhoneNumber: function formatPhoneNumber(phoneNumberString) {
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
            var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                var intlCode = match[1] ? '+1 ' : '';
                return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
            }
            return null;
        }
    },
    mounted: function mounted() {

        amplitude.getInstance().logEvent('signup_page_ohananum_loaded');

        var originalNumber = this.$parent.ohanaNumber;
        var oneRemoved = originalNumber.slice(2);
        var formattedNumber = this.formatPhoneNumber(oneRemoved);

        this.ohanaNumber = formattedNumber;

        var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["b" /* TimelineMax */]({
            delay: 1
        });
        var _$refs = this.$refs,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            form = _$refs.form,
            button = _$refs.button,
            phone = _$refs.phone;

        tl.from([title, subtitle, phone], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_app_store_download_button_svg__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_app_store_download_button_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_app_store_download_button_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["b" /* TimelineMax */]({
    delay: 1
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Step8_Welcome',
    methods: {
        goNextStep: function goNextStep() {
            // This needs to route to the Ohana index
            window.location.href = 'https://ohanaisfamily.com/';
        }
    },
    components: {
        downloadButton: __WEBPACK_IMPORTED_MODULE_1__assets_svg_app_store_download_button_svg___default.a
    },
    mounted: function mounted() {

        amplitude.getInstance().logEvent('signup_page_final_loaded');

        var _$refs = this.$refs,
            title = _$refs.title,
            welcome = _$refs.welcome,
            subtitle = _$refs.subtitle,
            button = _$refs.button;

        tl.from([title, welcome, subtitle], 1.2, { autoAlpha: 0, ease: Power2.easeOut }).from(button, 1.2, { scale: .9, autoAlpha: 0, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_1_common_ErrorModal__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_1_common_ErrorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_1_common_ErrorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_1_common_Preloader__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_1_common_Preloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_1_common_Preloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_firebaseConfig__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_deleteAccount__ = __webpack_require__(262);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Delete',
    components: {
        ErrorModal: __WEBPACK_IMPORTED_MODULE_2__components_1_common_ErrorModal___default.a,
        Preloader: __WEBPACK_IMPORTED_MODULE_3__components_1_common_Preloader___default.a,
        InputField: __WEBPACK_IMPORTED_MODULE_4__components_1_common_InputField___default.a
    },
    data: function data() {
        return {
            errorPopup: false, // Show Error Popup
            preloaderShow: false, // Show Preloader
            uid: '',
            uidFound: false,
            errorMessage: '',
            foundName: '',
            foundEmail: '',
            foundNumber: '',
            foundContactsCount: '',
            foundMessagesCount: '',
            foundSubscriptionStatus: false,
            logEntries: [],
            inputDisabled: false,
            buttonDisabled: false,
            resetButtonDisabled: true,
            passwordProtect: true,
            pword: ''
        };
    },

    watch: {
        pword: function pword(newVal, oldVal) {

            if (this.pword == 'dangerzone') {
                this.passwordProtect = false;
            }
        }
    },
    computed: {
        userGetter: function userGetter() {
            var _this = this;

            this.foundName = '';
            this.foundEmail = '';
            this.errorMessage = '';
            this.foundNumber = '';
            this.foundContactsCount = '';
            this.foundMessagesCount = '';
            this.foundSubscriptionStatus = false;

            // Protect against empty uid
            if (this.uid == '') {
                return;
            }

            var userRef = __WEBPACK_IMPORTED_MODULE_5__tools_firebaseConfig__["usersCollection"].child(this.uid);
            userRef.once('value').then(function (userFound) {

                // Make sure returned object is one currently in box
                if (userFound.key != _this.uid) {
                    return;
                }

                _this.uidFound = userFound.exists();

                // Exit if doesn't exist
                if (!userFound.exists()) {
                    _this.errorMessage = 'User \"' + _this.uid + '\" not found';
                    return;
                }

                _this.errorMessage = '';

                _this.foundName = userFound.val().name;
                _this.foundEmail = userFound.val().email;
                _this.foundNumber = userFound.val().phone || 'nil';
                _this.foundSubscriptionStatus = userFound.val().subscriptionStatus || false;

                if (userFound.val().contacts != null) {
                    var contactsLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userFound.val().contacts).length;
                    _this.foundContactsCount = contactsLength.toString();
                } else {
                    _this.foundContactsCount = 'NONE';
                }

                // Get Messages
                if (userFound.val().phone != null) {
                    __WEBPACK_IMPORTED_MODULE_5__tools_firebaseConfig__["messagesCollection"].child(_this.foundNumber).once('value').then(function (messagesFound) {
                        if (messagesFound.exists()) {
                            // console.log(messagesFound.val());
                            var messageRecips = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(messagesFound.val()).length;
                            // console.log(messageRecips)
                            var messagesArrayOfArrays = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(messagesFound.val());

                            var allMessages = [];
                            messagesArrayOfArrays.forEach(function (array) {
                                var actualArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(array);
                                allMessages = allMessages.concat(actualArray);
                            });

                            console.log(allMessages);

                            _this.foundMessagesCount = allMessages.length.toString();
                        } else {

                            _this.foundMessagesCount = 'NONE';
                        }
                    }).catch(function (error) {
                        console.log('error looking for messages:');
                        console.log(error);
                    });
                } else {
                    _this.foundMessagesCount = 'NONE';
                }

                console.log('user found!:');
                console.log(userFound.exists());
                console.log(userFound.val().email);
                // console.log(userRef.toJSON())
            }).catch(function (error) {
                console.log('uhhh, I think not found?');
                console.log(error);
            });

            return '';
        }
    },
    methods: {
        deleteUser: function deleteUser() {
            var _this2 = this;

            if (this.buttonDisabled) {
                console.log('button disabled');
                window.alert("Please clear current delete.");
                return;
            }

            if (!this.uidFound) {
                console.log('uid not found!');
                window.alert("UID not found.");
                return;
            }

            if (this.isProtectedUser(this.uid)) {
                console.log('TRIED TO DELETE PROTECTED USER!');
                window.alert("THIS USER IS PROTECTED! Ask Vince to delete.");
                return;
            }

            var confirmed = confirm("Are you sure you want to delete this user?\nThis operation is permanent!");
            if (!confirmed) {
                console.log('operation cancelled');
                return;
            }

            this.inputDisabled = true;
            this.buttonDisabled = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tools_deleteAccount__["a" /* default */])(this.uid, function (newLogEntry) {
                _this2.logEntries.push(newLogEntry);
            }).then(function () {
                console.log('done');
                _this2.resetButtonDisabled = false;
            });
        },
        resetClicked: function resetClicked() {

            if (this.resetButtonDisabled) {
                console.log('button is disabled, not sure how it was clicked...');
                return;
            }

            this.uid = '';
            this.uidFound = false;
            this.errorMessage = '';
            this.foundName = '';
            this.foundEmail = '';
            this.foundNumber = '';
            this.foundContactsCount = '';
            this.foundMessagesCount = '';
            this.foundSubscriptionStatus = false;
            this.logEntries = [];
            this.inputDisabled = false;
            this.buttonDisabled = false;
            this.resetButtonDisabled = true;
        },
        showLoading: function showLoading() {
            // console.log('showLoading called');
            this.preloaderShow = true;
        },
        dismissLoading: function dismissLoading() {
            console.log('dismissing loading');
            this.preloaderShow = false;
        },
        showError: function showError(message) {
            console.log('show error called');
            // this.error_message = message;
            this.errorPopup = true;
        },
        dismissError: function dismissError() {
            console.log('dismissing error');
            this.errorPopup = false;
        },
        isProtectedUser: function isProtectedUser(uid) {

            var protectedUIDs = ['88n3CkBsoiXdU8E5LYPi1s1tT6d2', 'JkMG1WN3ZeZZo3fsdjmtMve8NFN2', 'UmAroqbKDDOT4SV1vDolpVCQHiu2', 'bdfGfzR2kqgresVhVkL6wvzsfNu1'];

            return protectedUIDs.includes(uid);
        }
    }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_logo_svg__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_logo_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["b" /* TimelineMax */]({
    delay: 0.5
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Landing',
    components: {
        logo: __WEBPACK_IMPORTED_MODULE_1__assets_svg_logo_svg___default.a
    },
    methods: {
        readyClicked: function readyClicked() {
            this.$emit('nextStep');
        }
    },
    mounted: function mounted() {
        var _$refs = this.$refs,
            logo = _$refs.logo,
            title = _$refs.title,
            subtitle = _$refs.subtitle,
            button = _$refs.button;

        tl.from(logo, .9, { scale: .8, autoAlpha: 0, ease: Power2.easeOut }).from([title, subtitle], 0.8, { autoAlpha: 0, ease: Power2.easeOut }, "-=.4").from(button, 1.2, { autoAlpha: 0, y: 100, ease: Power2.easeOut }, "-=.8");
    }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_ErrorModal__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_ErrorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_1_common_ErrorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_1_common_Preloader__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_1_common_Preloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_1_common_Preloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_3_pages_Landing__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_3_pages_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_3_pages_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_2_blocks_Step1_AccHolder__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_2_blocks_Step1_AccHolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_2_blocks_Step1_AccHolder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_2_blocks_Step2_MakeAcc__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_2_blocks_Step2_MakeAcc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_2_blocks_Step2_MakeAcc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_2_blocks_Step3_MobileNum__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_2_blocks_Step3_MobileNum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_2_blocks_Step3_MobileNum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_2_blocks_Step4_AddContacts__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_2_blocks_Step4_AddContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_2_blocks_Step4_AddContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_2_blocks_Step5_CreditCard__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_2_blocks_Step5_CreditCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_2_blocks_Step5_CreditCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_2_blocks_Step6_MakeNum__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_2_blocks_Step6_MakeNum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_2_blocks_Step6_MakeNum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_2_blocks_Step7_OhanaNum__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_2_blocks_Step7_OhanaNum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_2_blocks_Step7_OhanaNum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_2_blocks_Step8_Welcome__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_2_blocks_Step8_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_2_blocks_Step8_Welcome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import step1 from '@/components/2-blocks/step1';
// import step2 from '@/components/2-blocks/step2';
// import step3 from '@/components/2-blocks/step3';









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Signup',
    components: {
        ArrowIcon: __WEBPACK_IMPORTED_MODULE_0__assets_svg_arrow_svg___default.a,
        Landing: __WEBPACK_IMPORTED_MODULE_3__components_3_pages_Landing___default.a,
        ErrorModal: __WEBPACK_IMPORTED_MODULE_1__components_1_common_ErrorModal___default.a,
        Preloader: __WEBPACK_IMPORTED_MODULE_2__components_1_common_Preloader___default.a
    },
    mounted: function mounted() {
        console.log('Signup mounted');
        amplitude.getInstance().logEvent('signup_loaded');
    },
    data: function data() {
        return {
            stepComponent: [__WEBPACK_IMPORTED_MODULE_4__components_2_blocks_Step1_AccHolder___default.a, __WEBPACK_IMPORTED_MODULE_5__components_2_blocks_Step2_MakeAcc___default.a, __WEBPACK_IMPORTED_MODULE_6__components_2_blocks_Step3_MobileNum___default.a, __WEBPACK_IMPORTED_MODULE_7__components_2_blocks_Step4_AddContacts___default.a, __WEBPACK_IMPORTED_MODULE_8__components_2_blocks_Step5_CreditCard___default.a, __WEBPACK_IMPORTED_MODULE_9__components_2_blocks_Step6_MakeNum___default.a, __WEBPACK_IMPORTED_MODULE_10__components_2_blocks_Step7_OhanaNum___default.a, __WEBPACK_IMPORTED_MODULE_11__components_2_blocks_Step8_Welcome___default.a],
            stepIdx: 0,
            displayLanding: true,
            errorPopup: false, // Show Error Popup
            preloaderShow: false, // Show Preloader
            currentUid: null,
            currentName: null,
            currentEmail: null,
            ohanaNumber: null
        };
    },

    methods: {
        showLoading: function showLoading() {
            // console.log('showLoading called');
            this.preloaderShow = true;
        },
        dismissLoading: function dismissLoading() {
            console.log('dismissing loading');
            this.preloaderShow = false;
        },
        showError: function showError(message) {
            console.log('show error called');
            this.error_message = message;
            this.errorPopup = true;
        },
        dismissError: function dismissError() {
            console.log('dismissing error');
            this.errorPopup = false;
        },
        prevStep: function prevStep() {
            if (this.stepIdx === 0) {
                this.displayLanding = true;
            } else {
                this.stepIdx = this.stepIdx - 1;
            }
        },
        nextStep: function nextStep() {

            if (this.displayLanding) {
                this.displayLanding = false;
                return;
            }

            this.stepIdx = this.stepIdx + 1;
        }
    }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_ErrorModal__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_1_common_ErrorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_1_common_ErrorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_Preloader__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_1_common_Preloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_1_common_Preloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_1_common_InputField__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_1_common_InputField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_1_common_InputField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_logEntryFile__ = __webpack_require__(161);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Test',
    components: {
        ErrorModal: __WEBPACK_IMPORTED_MODULE_0__components_1_common_ErrorModal___default.a,
        Preloader: __WEBPACK_IMPORTED_MODULE_1__components_1_common_Preloader___default.a,
        InputField: __WEBPACK_IMPORTED_MODULE_2__components_1_common_InputField___default.a
    },
    data: function data() {
        return {
            duh: false
        };
    },

    computed: {

        userGetter: function userGetter() {

            return '';
        }
    },
    methods: {
        buttonClicked: function buttonClicked() {

            console.log('button clicked!');
        }
    }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
window.requestAnimFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function */callback, /* DOMElement */element) {
        window.setTimeout(callback, 1000 / 60);
    };
}();

window.requestTimeout = function (fn, delay) {
    if (!window.requestAnimationFrame && !window.webkitRequestAnimationFrame && !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) && // Firefox 5 ships without cancel support
    !window.oRequestAnimationFrame && !window.msRequestAnimationFrame) return window.setTimeout(fn, delay);

    var start = new Date().getTime(),
        handle = new Object();

    function loop() {
        var current = new Date().getTime(),
            delta = current - start;

        delta >= delay ? fn.call() : handle = requestAnimFrame(loop);
    };

    handle = requestAnimFrame(loop);
    return handle;
};

window.clearRequestTimeout = function (handle) {
    window.cancelAnimationFrame ? window.cancelAnimationFrame(handle) : window.webkitCancelAnimationFrame ? window.webkitCancelAnimationFrame(handle) : window.webkitCancelRequestAnimationFrame ? window.webkitCancelRequestAnimationFrame(handle) : /* Support for legacy API */
    window.mozCancelRequestAnimationFrame ? window.mozCancelRequestAnimationFrame(handle) : window.oCancelRequestAnimationFrame ? window.oCancelRequestAnimationFrame(handle) : window.msCancelRequestAnimationFrame ? window.msCancelRequestAnimationFrame(handle) : clearTimeout(handle);
};

var Helpers = {
    isMobile: function isMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check || window.innerWidth < 769;
        // return false
    },
    isTouch: function isTouch() {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
        return isMobile;
    },
    iOS: function iOS() {
        var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }

        return false;
    },
    isIPAD: function isIPAD() {
        var ua = navigator.userAgent;
        return (/iPad/i.test(ua) || /iPhone OS 3_1_2/i.test(ua) || /iPhone OS 3_2_2/i.test(ua)
        );
    },
    get_browser_info: function get_browser_info() {
        var ua = navigator.userAgent,
            tem = void 0,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE ', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return { name: 'Opera', version: tem[1] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    },
    getRandomInt: function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    },
    getRandomFromArray: function getRandomFromArray(array) {
        return array[getRandomInt(0, array.length - 1)];
    },
    declension: function declension(num, expressions) {
        var result = void 0;
        var count = num % 100;
        if (count >= 5 && count <= 20) {
            result = expressions['2'];
        } else {
            count = count % 10;
            if (count == 1) {
                result = expressions['0'];
            } else if (count >= 2 && count <= 4) {
                result = expressions['1'];
            } else {
                result = expressions['2'];
            }
        }
        return result;
    },
    isIE: function isIE() {
        var ua = window.navigator.userAgent;
        if (ua.indexOf('Edge/') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0) {
            return true;
        } else {
            return false;
        }
    },
    ga: function (_ga) {
        function ga() {
            return _ga.apply(this, arguments);
        }

        ga.toString = function () {
            return _ga.toString();
        };

        return ga;
    }(function () {
        var analitics = {
            send: function send(category, action, label, id) {
                if (typeof ga !== 'undefined') {

                    if (typeof label !== 'undefined' && label !== '') {
                        if (id) ga('send', 'event', category, action, label, id);else ga('send', 'event', category, action, label);
                    } else {
                        ga('send', 'event', category, action);
                    }
                }
            }
        };
        return analitics;
    }),
    datalayer: function datalayer(data) {
        if ('dataLayer' in window) {
            dataLayer.push(data);
            return true;
        }
    },


    isScrolledIntoView: function isScrolledIntoView(el) {
        var elemTop = el.getBoundingClientRect().top;
        var elemBottom = el.getBoundingClientRect().bottom;
        var elHeight = elemBottom - elemTop;
        //return (elemTop >= -window.innerHeight/2) && (elemTop <= window.innerHeight/2) && (elemBottom >= window.innerHeight/2) && (elemBottom <= 3*window.innerHeight/2);
        return elemBottom <= elHeight;
    },

    dLayer: function dLayer(data) {
        if ('dataLayer' in window) {
            dataLayer.push(data);
        }
    },

    getOS: function getOS() {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    },
    isMac: function isMac() {
        return this.getOS() === 'Mac OS';
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Helpers);

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logEntryFile__ = __webpack_require__(161);






var deleteContacts = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(contacts, logCallback) {
        var contactIds, contactPromises;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        if (!(contacts == null)) {
                            _context2.next = 4;
                            break;
                        }

                        console.log('no contacts!');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('No contacts!', "grey"));
                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve());

                    case 4:

                        console.log('deleting contacts...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting contacts...', "black"));

                        contactIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(contacts);
                        contactPromises = contactIds.map(function (contactId) {

                            return __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["contactsCollection"].child(contactId).remove() // LIVE: change to remove()
                            .then(function () {
                                console.log('successfully deleted contact: ' + contactId);
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('successfully deleted contact: ' + contactId, "black"));
                            }).catch(function (error) {
                                console.log('%cerror deleting contact ' + contactId + ' from database', 'color: red');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error deleting contact ' + contactId + ' from database', "red"));
                                console.log(error);
                            });
                        });
                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(contactPromises).then(function () {
                            console.log('%ccontacts deleted from database!', 'color: green');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('contacts deleted from database!', "green"));
                        }));

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function deleteContacts(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

var deleteMessages = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(phoneNumber, logCallback) {
        var messagesModel, messagesRecipArray, messages, pictureMessages, audioMessages;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!(phoneNumber == null)) {
                            _context3.next = 4;
                            break;
                        }

                        console.log('no number, so no messages!');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('no number, so no messages either!', "gray"));
                        return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve());

                    case 4:
                        _context3.next = 6;
                        return __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["messagesCollection"].child(phoneNumber).once('value');

                    case 6:
                        messagesModel = _context3.sent;

                        if (messagesModel.exists()) {
                            _context3.next = 11;
                            break;
                        }

                        console.log('no messages!');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('no messages!', "gray"));
                        return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve());

                    case 11:

                        console.log('deleting messages...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting messages...', "black"));

                        messagesRecipArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(messagesModel.val());
                        messages = messagesRecipArray.reduce(function (prev, currVal) {

                            var messageValues = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(currVal);
                            return messageValues.concat(prev);
                        }, []);
                        pictureMessages = messages.filter(function (message) {
                            return message.imageUrl != null;
                        });
                        audioMessages = messages.filter(function (message) {
                            return message.audioUrl != null && !message.audioUrl.startsWith('-');
                        });


                        console.log(pictureMessages);
                        console.log(audioMessages);

                        console.log('deleting picture messages from storage...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting picture messages from storage...', "black"));
                        _context3.next = 23;
                        return deletePictureMessages(pictureMessages, logCallback);

                    case 23:
                        console.log('%cdeleted picture messages from storage!', 'color: green');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleted picture messages from storage!', "green"));

                        console.log('deleting audio messages from storage...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting audio messages from storage...', "black"));
                        _context3.next = 29;
                        return deleteAudioMessages(audioMessages, logCallback);

                    case 29:
                        console.log('%cdeleted audio messages from storage!', 'color: green');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleted audio messages from storage!', "green"));

                        console.log('deleting messages from database...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting messages from database...', "black"));
                        return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["messagesCollection"].child(phoneNumber).remove() // LIVE: change to remove()
                        .then(function () {
                            console.log('%cmessages deleted from database!', 'color: green');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('messages deleted from database!', "green"));
                        }).catch(function (error) {

                            console.log('%cerror deleting messages from database:', 'color: red');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('messages deleted from database!', "green"));
                            console.log(error);
                        }));

                    case 34:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function deleteMessages(_x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();

var deleteUserAuth = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(uid, logCallback) {
        var deleteUserURL, body, axios;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:

                        console.log('deleting user from Auth...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting user from Auth...', "black"));

                        deleteUserURL = 'https://old.ohanaisfamily.com/api/deleteUser';
                        body = {
                            uid: uid
                        };
                        axios = __webpack_require__(77);
                        return _context4.abrupt('return', axios.post(deleteUserURL, body).then(function (response) {

                            if (response.data.success) {
                                console.log('%cuser ' + uid + ' successfully deleted from Auth!', 'color: green');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('user ' + uid + ' successfully deleted from Auth!', "green"));
                            } else {
                                console.log('%cERROR! something went wrong trying to delete user from Auth here is returned response:', 'color: red');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('ERROR! something went wrong trying to delete user from Auth', "red"));
                                console.log(response);
                            }
                        }).catch(function (error) {
                            console.log('%cAxios got error trying to delete User from Auth:', 'color: red');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('Axios got error trying to delete User from Auth', "red"));
                            console.log(error);
                        }));

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function deleteUserAuth(_x7, _x8) {
        return _ref4.apply(this, arguments);
    };
}();

var deleteUserModel = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(uid, logCallback) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:

                        console.log('deleting user model from DB...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting user model from DB...', "black"));

                        return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["usersCollection"].child(uid).remove() // LIVE: change to remove()
                        .then(function () {
                            console.log('%cdeleted User model from DB!', 'color: green');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleted User model from DB!', "green"));
                        }).catch(function (error) {
                            console.log('%cerror deleting User model from DB:', 'color: red');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error deleting User model from DB', "red"));
                            console.log(error);
                        }));

                    case 3:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function deleteUserModel(_x9, _x10) {
        return _ref5.apply(this, arguments);
    };
}();

var deleteUserImagesFiles = function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(uid, logCallback) {
        var storageRef, fileRefs, deletePromises;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        storageRef = __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["storage"].ref('UserImages/' + uid);
                        _context6.next = 3;
                        return storageRef.listAll().then(function (result) {
                            return result.items;
                        }).catch(function (error) {
                            console.log('%cerror getting storage folder content refs for: ' + storageRef.fullPath, 'color: red');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error getting storage folder content refs for: ' + storageRef.fullPath, "red"));
                            console.log(error);
                        });

                    case 3:
                        fileRefs = _context6.sent;
                        deletePromises = fileRefs.map(function (ref) {
                            return ref.delete() // LIVE: change to delete()
                            .then(function () {
                                console.log('successfully deleted UserImages file: ' + ref.fullPath);
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('successfully deleted UserImages file: ' + ref.fullPath, "green"));
                            }).catch(function (error) {
                                console.log('%cerror deleting UserImages file from Storage:', 'color: red');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error deleting UserImages file from Storage', "red"));
                                console.log(storageRef.fullPath);
                                console.log(error);
                            });
                        });
                        return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(deletePromises).then(function () {
                            console.log('%cdeleted all files from user Storage folder: ' + storageRef.fullPath, 'color: green');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleted all files from user Storage folder: ' + storageRef.fullPath, "green"));
                        }));

                    case 6:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function deleteUserImagesFiles(_x11, _x12) {
        return _ref6.apply(this, arguments);
    };
}();

var deleteNumberFromTwilio = function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(phoneNumber, logCallback) {
        var deleteNumberURL, body, axios;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        if (!(phoneNumber == null)) {
                            _context7.next = 4;
                            break;
                        }

                        console.log('no number to delete from Twilio!');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('no number to delete from Twilio!', "gray"));
                        return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve());

                    case 4:

                        console.log('deleting number delete request to Twilio...');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleting number delete request to Twilio...', "black"));

                        deleteNumberURL = 'https://old.ohanaisfamily.com/api/deleteNumber';
                        body = {
                            phoneNumber: phoneNumber // LIVE: change this to phoneNumber: phoneNumber
                        };
                        axios = __webpack_require__(77);
                        _context7.next = 11;
                        return axios.post(deleteNumberURL, body).then(function (response) {

                            if (response.data.success) {
                                console.log('%cnumber ' + phoneNumber + ' successfully deleted from Twilio!', 'color: green');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('number ' + phoneNumber + ' successfully deleted from Twilio!', "green"));
                            } else {
                                console.log('%cERROR! something went wrong trying to delete number, check Twilio... here is returned response', 'color: red');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('ERROR! something went wrong trying to delete number, check Twilio...', "red"));
                                console.log(response);
                            }
                        }).catch(function (error) {
                            console.log('%cgot error trying to deleteNumber:', 'color: red');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('got error trying to deleteNumber', "red"));
                            console.log(error);
                        });

                    case 11:
                        return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["numToUidCollection"].child(phoneNumber).remove() // LIVE: change to remove()
                        .then(function () {
                            console.log('%cdeleted NumberToUid entry!', 'color: green');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('deleted NumberToUid entry!', "green"));
                        }).catch(function (error) {
                            console.log('%cerror deleting NumberToUid entry:', 'color: red');
                            logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error deleting NumberToUid entry', "red"));
                            console.log(error);
                        }));

                    case 12:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function deleteNumberFromTwilio(_x13, _x14) {
        return _ref7.apply(this, arguments);
    };
}();

var deleteAudioMessages = function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8(audioMessages, logCallback) {
        var audioUrls, storageRefs, deletePromises;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        audioUrls = audioMessages.map(function (message) {
                            return message.audioUrl;
                        });
                        storageRefs = audioUrls.map(function (url) {
                            return __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["storage"].refFromURL(url);
                        });
                        deletePromises = storageRefs.map(function (ref) {
                            return ref.delete() // LIVE: change to delete()
                            .then(function () {
                                console.log('successfully deleted audio message: ' + ref.fullPath);
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('successfully deleted audio message: ' + ref.fullPath, "black"));
                            }).catch(function (error) {
                                console.log('%cerror deleting audio message:', 'color: red');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error deleting audio message: ' + ref.fullPath, "red"));
                                console.log(ref.fullPath);
                                console.log(error);
                            });
                        });
                        return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(deletePromises));

                    case 4:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function deleteAudioMessages(_x15, _x16) {
        return _ref8.apply(this, arguments);
    };
}();

var deletePictureMessages = function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9(pictureMessages, logCallback) {
        var imageFilenames, storageRefs, deletePromises;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        imageFilenames = pictureMessages.map(function (message) {
                            return message.imageUrl;
                        });
                        storageRefs = imageFilenames.map(function (filename) {
                            return __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["storage"].ref('MessageAttachments/' + filename);
                        });
                        deletePromises = storageRefs.map(function (ref) {
                            return ref.delete() // LIVE: change to delete()
                            .then(function () {
                                console.log('successfully deleted picture message: ' + ref.fullPath);
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('successfully deleted picture message: ' + ref.fullPath, "black"));
                            }).catch(function (error) {
                                console.log('%cerror deleting picture message:', 'color: red');
                                logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])('error deleting picture message: ' + ref.fullPath, "red"));

                                console.log(ref.fullPath);
                                console.log(error);
                            });
                        });
                        return _context9.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(deletePromises));

                    case 4:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function deletePictureMessages(_x17, _x18) {
        return _ref9.apply(this, arguments);
    };
}();




/* harmony default export */ __webpack_exports__["a"] = ((function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(uid, logCallback) {
        var userModel, contacts, phoneNumber;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:

                        console.log('hello');

                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_5__firebaseConfig__["usersCollection"].child(uid).once('value');

                    case 3:
                        userModel = _context.sent;
                        contacts = userModel.val().contacts;
                        phoneNumber = userModel.val().phone;
                        _context.next = 8;
                        return deleteContacts(contacts, logCallback);

                    case 8:
                        _context.next = 10;
                        return deleteMessages(phoneNumber, logCallback);

                    case 10:
                        _context.next = 12;
                        return deleteNumberFromTwilio(phoneNumber, logCallback);

                    case 12:
                        _context.next = 14;
                        return deleteUserImagesFiles(uid, logCallback);

                    case 14:
                        _context.next = 16;
                        return deleteUserModel(uid, logCallback);

                    case 16:
                        _context.next = 18;
                        return deleteUserAuth(uid, logCallback);

                    case 18:

                        console.log('%caccount should be deleted!', 'color: green');
                        logCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__logEntryFile__["a" /* logEntry */])("Account Deleted!", "green"));

                    case 20:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function deleteAccount(_x, _x2) {
        return _ref.apply(this, arguments);
    }

    return deleteAccount;
})());

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(547),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(538),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be7b37b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(536),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Please make your Ohana account.")])]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('InputField', {
    attrs: {
      "title": "FULL NAME",
      "type": "name",
      "placeholder": "First Last",
      "autocomplete": "name",
      "autocapitalize": "words",
      "disabled": false,
      "errored": false,
      "validated": _vm.nameValid,
      "errorMessage": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('InputField', {
    attrs: {
      "title": "EMAIL",
      "type": "email",
      "placeholder": "email@hello.com",
      "autocomplete": "email",
      "autocapitalize": "off",
      "disabled": false,
      "errored": false,
      "validated": _vm.emailValid,
      "errorMessage": _vm.emailErrorMessage
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('InputField', {
    attrs: {
      "title": "PASSWORD",
      "type": "password",
      "placeholder": "password",
      "disabled": false,
      "errorMessage": "",
      "validated": _vm.passwordValid
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button",
    class: {
      'button--disable': (!_vm.isValid())
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Create Account")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step__form-links"
  }, [_c('p', [_vm._v("By creating an account you agree to our "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ohanaisfamily.com/privacy-policy.html",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://ohanaisfamily.com/terms-and-conditions.html",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use.")])])])
}]}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete"
  }, [(_vm.passwordProtect) ? _c('div', {
    staticClass: "signup__container"
  }, [_c('InputField', {
    attrs: {
      "title": "Hello",
      "type": "text",
      "placeholder": "football",
      "autocomplete": "none",
      "autocapitalize": "off",
      "disabled": false,
      "errored": false,
      "errorMessage": ""
    },
    model: {
      value: (_vm.pword),
      callback: function($$v) {
        _vm.pword = $$v
      },
      expression: "pword"
    }
  })], 1) : _c('div', [(_vm.preloaderShow) ? _c('Preloader') : _vm._e(), _vm._v(" "), (_vm.errorPopup) ? _c('ErrorModal', {
    attrs: {
      "title": "Error",
      "message": "An error occurred."
    },
    on: {
      "dismissError": _vm.dismissError
    }
  }) : _c('div', {
    staticClass: "signup__container"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Delete Ohana User")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle--delete"
  }, [_c('p', [_vm._v("This will delete the user and all data associated with the user (contacts, messages, photos, Twilio Phone Number)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('InputField', {
    attrs: {
      "title": "UID",
      "type": "text",
      "placeholder": "abcd1234",
      "autocomplete": "text",
      "autocapitalize": "off",
      "disabled": _vm.inputDisabled,
      "errored": _vm.uidFound,
      "errorMessage": _vm.errorMessage
    },
    model: {
      value: (_vm.uid),
      callback: function($$v) {
        _vm.uid = $$v
      },
      expression: "uid"
    }
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.userGetter) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundSubscriptionStatus),
      expression: "foundSubscriptionStatus"
    }],
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5em",
      "color": "red",
      "font-weight": "700"
    }
  }, [_vm._v("THIS USER IS A SUBSCRIBER")]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundName),
      expression: "foundName"
    }]
  }, [_vm._v("Name:      " + _vm._s(_vm.foundName) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundEmail),
      expression: "foundEmail"
    }]
  }, [_vm._v("Email:       " + _vm._s(_vm.foundEmail) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundNumber),
      expression: "foundNumber"
    }]
  }, [_vm._v("Phone:     " + _vm._s(_vm.foundNumber) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundContactsCount),
      expression: "foundContactsCount"
    }]
  }, [_vm._v("Contacts:     " + _vm._s(_vm.foundContactsCount) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundMessagesCount),
      expression: "foundMessagesCount"
    }]
  }, [_vm._v("Messages:     " + _vm._s(_vm.foundMessagesCount) + " ")])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    class: {
      'button--disable': !this.uidFound || this.buttonDisabled,
        'button button--full': true
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteUser($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Delete Account")]), _vm._v(" "), _c('span', {
    staticClass: "button__subtitle"
  }, [_vm._v("This is PERMANENT")])])]), _vm._v(" "), (!_vm.resetButtonDisabled) ? _c('div', {
    staticClass: "step__button--reset"
  }, [_c('a', {
    class: {
      'button button--full': true
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetClicked($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Reset")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.logEntries.length) ? _c('div', {
    staticClass: "log"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Log")]), _vm._v(" "), _c('ul', _vm._l((_vm.logEntries), function(entry) {
    return _c('li', {
      style: ({
        color: entry.color
      })
    }, [_vm._v(" " + _vm._s(entry.message) + " ")])
  }), 0)]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', {
    staticClass: "landing__container"
  }, [_c('div', {
    ref: "logo",
    staticClass: "landing__logo"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('logo', {
    ref: "logo",
    attrs: {
      "alt": "logo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "title",
    staticClass: "landing__title"
  }, [_c('p', [_vm._v("Hello!")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "landing__subtitle"
  }, [_vm._m(0)])]), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "landing__button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.readyClicked
    }
  }, [_c('span', [_vm._v("I'm Ready")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Ready to reconnect"), _c('br'), _vm._v(" the whole family?")])
}]}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete"
  }, [_c('div', {
    staticClass: "signup__container"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    class: {
      'button button--full': true
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.buttonClicked($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Test button")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Your Ohana phone number")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("Write this down and use it to text and call your loved one.")])]), _vm._v(" "), _c('div', {
    ref: "phone",
    staticClass: "step__you-phone"
  }, [_c('p', [_vm._v(_vm._s(_vm.ohanaNumber))])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button step__button--bottom"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      fontSize: _vm.fSize + 'px'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("You’ll be the master account holder for this person.")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("That means you’re email will be the main point of contact and receive updates and new information.")])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step step--7"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Let’s add more contacts for your loved one to call.")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("Optional")])]), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, _vm._l((_vm.contacts), function(contact, index) {
    return _c('div', {
      key: index,
      staticClass: "step__form-block"
    }, [_c('InputField', {
      attrs: {
        "title": "NAME",
        "type": "text",
        "placeholder": "Name",
        "autocomplete": "",
        "disabled": false,
        "errored": false,
        "validated": _vm.nameValid(contact.name),
        "errorMessage": ""
      },
      model: {
        value: (contact.name),
        callback: function($$v) {
          _vm.$set(contact, "name", $$v)
        },
        expression: "contact.name"
      }
    }), _vm._v(" "), _c('InputField', {
      attrs: {
        "title": "MOBILE NUMBER",
        "type": "tel",
        "placeholder": "(123) 456-7890",
        "autocomplete": "mobile tel",
        "disabled": false,
        "errored": false,
        "validated": _vm.numberValid(contact.phone),
        "errorMessage": "",
        "mask": "(###) ###-####"
      },
      model: {
        value: (contact.phone),
        callback: function($$v) {
          _vm.$set(contact, "phone", $$v)
        },
        expression: "contact.phone"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('a', {
    ref: "addButton",
    staticClass: "step__add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addContactForm($event)
      }
    }
  }, [_c('span', {
    staticClass: "step__add-info"
  }, [_c('span', {
    staticClass: "step__add-icon"
  }, [_c('plusIcon')], 1), _vm._v(" "), _c('span', {
    staticClass: "step__add-name"
  }, [_vm._v("add another contact")])])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Your mobile phone number")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("You will be added as their first contact")])]), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('InputField', {
    attrs: {
      "title": "MOBILE NUMBER",
      "type": "tel",
      "placeholder": "(123) 456-7890",
      "autocomplete": "mobile tel",
      "disabled": false,
      "errored": false,
      "validated": _vm.numberValid,
      "errorMessage": "",
      "mask": "(###) ###-####"
    },
    model: {
      value: (_vm.phoneNumber),
      callback: function($$v) {
        _vm.phoneNumber = $$v
      },
      expression: "phoneNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button step__button--bottom"
  }, [_c('a', {
    staticClass: "button",
    class: {
      'button--disable': !this.numberValid
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "preloader__background"
  }), _vm._v(" "), _c('div', {
    staticClass: "preloader__animation"
  }, [_c('div', {
    staticClass: "preloader__icon"
  }, [_c('PreloaderIcon')], 1), _vm._v(" "), _c('div', {
    staticClass: "preloader__text"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('p', {
    key: _vm.preloaderTextIdx,
    ref: "preload",
    domProps: {
      "innerHTML": _vm._s(_vm.preloaderText())
    }
  })])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input",
    class: [{
        'input--active': !_vm.empty && !_vm.disabled
      },
      {
        'input--disabled': _vm.disabled
      }
    ]
  }, [_c('form', [_c('label', {
    staticClass: "input__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "input__block"
  }, [((_vm.type) === 'checkbox' && (_vm.mask)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mask),
      expression: "mask"
    }],
    staticClass: "input__main",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, null) > -1 : (_vm.inputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }
    }
  }) : ((_vm.type) === 'radio' && (_vm.mask)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mask),
      expression: "mask"
    }],
    staticClass: "input__main",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.inputValue, null)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        _vm.inputValue = null
      }
    }
  }) : (_vm.mask) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mask),
      expression: "mask"
    }],
    staticClass: "input__main",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : ((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "input__main",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, null) > -1 : (_vm.inputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "input__main",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.inputValue, null)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        _vm.inputValue = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "input__main",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input__validate"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), (_vm.validated) ? _c('div', {
    staticClass: "input__check"
  }, [_c('checkWhiteIcon')], 1) : _vm._e(), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "input__check input__check--lock"
  }, [_c('checkLockIcon')], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Let’s make a number for your account")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("We will use the area code provided below to create your Ohana number.")])]), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('InputField', {
    attrs: {
      "title": "PHONE AREA CODE",
      "type": "tel",
      "placeholder": "415",
      "autocomplete": "tel",
      "disabled": false,
      "errored": false,
      "validated": _vm.areaCodeValid,
      "errorMessage": "",
      "mask": "###"
    },
    model: {
      value: (_vm.areaCode),
      callback: function($$v) {
        _vm.areaCode = $$v
      },
      expression: "areaCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button step__button--bottom"
  }, [_c('a', {
    staticClass: "button",
    class: {
      'button--disable': !_vm.areaCodeValid
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Create Number")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step step--8"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Now to start your 7 day free trial")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("We’ll need a credit card to get started, but don’t worry. You can cancel anytime before the end of the trial.")])]), _vm._v(" "), _c('div', {
    ref: "payment",
    staticClass: "step__payment"
  }, [_c('p', {
    staticClass: "step__payment-title"
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('cardsIcon')], 1), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('div', {
    staticClass: "step__form-block"
  }, [_c('InputField', {
    attrs: {
      "title": "NAME ON CARD",
      "type": "name",
      "placeholder": "Name",
      "autocomplete": "name",
      "autocapitalize": "words",
      "disabled": false,
      "errored": false,
      "validated": _vm.nameValid(_vm.cardName),
      "errorMessage": ""
    },
    model: {
      value: (_vm.cardName),
      callback: function($$v) {
        _vm.cardName = $$v
      },
      expression: "cardName"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('label', {
    staticClass: "input__label",
    attrs: {
      "for": "card"
    }
  }, [_vm._v("CARD INFO")]), _vm._v(" "), _c('div', {
    staticClass: "input__stripecard",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input__validate"
  }, [_c('p', [_vm._v(_vm._s(_vm.cardErrorMessage))])])])], 1)]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button button--full",
    class: {
      'button--disable': !this.isValid
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Start free trial")]), _vm._v(" "), _c('span', {
    staticClass: "button__subtitle"
  }, [_vm._v("\n                    You’ll be charged $1.00/month on " + _vm._s(_vm.weekFromNow()) + ".\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticClass: "input__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("NAME ON CARD")]), _vm._v(" "), _c('div', {
    staticClass: "input__block"
  }, [_c('input', {
    staticClass: "input__main",
    attrs: {
      "id": "name",
      "placeholder": "Name"
    }
  })])])
}]}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup"
  }, [(_vm.preloaderShow) ? _c('Preloader') : _vm._e(), _vm._v(" "), (_vm.errorPopup) ? _c('ErrorModal', {
    attrs: {
      "title": "Error",
      "message": "An error occurred."
    },
    on: {
      "dismissError": _vm.dismissError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayLanding) ? _c('Landing', {
    on: {
      "nextStep": _vm.nextStep
    }
  }) : _c('div', {
    staticClass: "signup__container"
  }, [_c('div', {
    staticClass: "signup__step"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v(_vm._s(_vm.stepIdx + 1))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.stepComponent.length))])]), _vm._v(" "), _c(_vm.stepComponent[_vm.stepIdx], {
    tag: "component",
    on: {
      "nextStep": _vm.nextStep,
      "showLoading": _vm.showLoading,
      "dismissLoading": _vm.dismissLoading,
      "showError": _vm.showError
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('Signup')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "error__background"
  }), _vm._v(" "), _c('div', {
    staticClass: "error__container"
  }, [_c('div', {
    staticClass: "error__title"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "error__text"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "error__button"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.dismissError($event)
      }
    }
  }, [_c('span', [_vm._v("OKAY")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "welcome",
    staticClass: "step__welcome"
  }, [_c('p', [_vm._v("Welcome to the family!")])]), _vm._v(" "), _c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Click the Download button below or search for us on the App Store. Log in with your account.")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("If you need any help at all just email us at help@ohanaisfamily.com or call us at (240) 543-2074")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ohanaisfamily.com/download"
    }
  }, [_c('downloadButton', {
    staticStyle: {
      "width": "15em",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "4em"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "step__button"
  }, [_c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.goNextStep
    }
  }, [_c('span', [_vm._v("Back to home")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="135" height="40" viewBox="0 0 135 40"><path fill="#A6A6A6" d="M130.197 40H4.729A4.74 4.74 0 0 1 0 35.267V4.726A4.733 4.733 0 0 1 4.729 0h125.468C132.803 0 135 2.12 135 4.726v30.541c0 2.605-2.197 4.733-4.803 4.733z"/><path d="M134.032 35.268a3.83 3.83 0 0 1-3.834 3.83H4.729a3.835 3.835 0 0 1-3.839-3.83V4.725A3.84 3.84 0 0 1 4.729.89h125.468a3.834 3.834 0 0 1 3.834 3.835l.001 30.543z"/><g fill="#FFF"><path d="M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.553 2.355 3.287 4.016 3.226 1.625-.067 2.232-1.036 4.193-1.036 1.943 0 2.513 1.036 4.207.997 1.744-.028 2.842-1.56 3.89-3.127 1.255-1.78 1.759-3.533 1.779-3.623-.041-.014-3.387-1.291-3.42-5.154zM26.928 10.306c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793z"/></g><g fill="#FFF"><path d="M53.645 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909H42.41l4.284-13.308h2.646l4.305 13.308zm-3.89-5.549L48.63 22.48c-.119-.355-.342-1.191-.671-2.507h-.04a96.75 96.75 0 0 1-.632 2.507l-1.105 3.475h3.573zM64.662 26.588c0 1.632-.441 2.922-1.323 3.869-.79.843-1.771 1.264-2.942 1.264-1.264 0-2.172-.454-2.725-1.362h-.04v5.055H55.5V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.711-1.146 1.79-1.718 3.238-1.718 1.132 0 2.077.447 2.833 1.342.758.896 1.136 2.074 1.136 3.535zm-2.172.078c0-.934-.21-1.704-.632-2.31-.461-.632-1.08-.948-1.856-.948-.526 0-1.004.176-1.431.523-.428.35-.708.807-.839 1.373-.066.264-.099.48-.099.65v1.6c0 .698.214 1.287.642 1.768s.984.721 1.668.721c.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM75.699 26.588c0 1.632-.441 2.922-1.324 3.869-.789.843-1.77 1.264-2.941 1.264-1.264 0-2.172-.454-2.724-1.362h-.04v5.055h-2.132V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.71-1.146 1.789-1.718 3.238-1.718 1.131 0 2.076.447 2.834 1.342.755.896 1.134 2.074 1.134 3.535zm-2.172.078c0-.934-.211-1.704-.633-2.31-.461-.632-1.078-.948-1.855-.948a2.22 2.22 0 0 0-1.432.523c-.428.35-.707.807-.838 1.373-.065.264-.099.48-.099.65v1.6c0 .698.214 1.287.64 1.768.428.48.984.721 1.67.721.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM88.039 27.772c0 1.132-.393 2.053-1.182 2.764-.867.777-2.074 1.165-3.625 1.165-1.432 0-2.58-.276-3.449-.829l.494-1.777c.936.566 1.963.85 3.082.85.803 0 1.428-.182 1.877-.544.447-.362.67-.848.67-1.454 0-.54-.184-.995-.553-1.364-.367-.369-.98-.712-1.836-1.029-2.33-.869-3.494-2.142-3.494-3.816 0-1.094.408-1.991 1.225-2.689.814-.699 1.9-1.048 3.258-1.048 1.211 0 2.217.211 3.02.632l-.533 1.738c-.75-.408-1.598-.612-2.547-.612-.75 0-1.336.185-1.756.553a1.58 1.58 0 0 0-.533 1.205c0 .526.203.961.611 1.303.355.316 1 .658 1.936 1.027 1.145.461 1.986 1 2.527 1.618.539.616.808 1.387.808 2.307zM95.088 23.508h-2.35v4.659c0 1.185.414 1.777 1.244 1.777.381 0 .697-.033.947-.099l.059 1.619c-.42.157-.973.236-1.658.236-.842 0-1.5-.257-1.975-.77-.473-.514-.711-1.376-.711-2.587v-4.837h-1.4v-1.6h1.4v-1.757l2.094-.632v2.389h2.35v1.602zM105.691 26.627c0 1.475-.422 2.686-1.264 3.633-.883.975-2.055 1.461-3.516 1.461-1.408 0-2.529-.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487.43-2.705 1.293-3.652.861-.948 2.023-1.422 3.484-1.422 1.408 0 2.541.467 3.396 1.402.818.907 1.226 2.078 1.226 3.513zm-2.212.069c0-.885-.189-1.644-.572-2.277-.447-.766-1.086-1.148-1.914-1.148-.857 0-1.508.383-1.955 1.148-.383.634-.572 1.405-.572 2.317 0 .885.189 1.644.572 2.276.461.766 1.105 1.148 1.936 1.148.814 0 1.453-.39 1.914-1.168.393-.645.591-1.412.591-2.296zM112.621 23.783a3.702 3.702 0 0 0-.672-.059c-.75 0-1.33.283-1.738.85-.355.5-.533 1.132-.533 1.895v5.035h-2.131l.02-6.574c0-1.106-.027-2.113-.08-3.021h1.857l.078 1.836h.059c.225-.631.58-1.139 1.066-1.52a2.578 2.578 0 0 1 1.541-.514c.197 0 .375.014.533.039v2.033zM122.156 26.252a5 5 0 0 1-.078.967h-6.396c.025.948.334 1.673.928 2.173.539.447 1.236.671 2.092.671.947 0 1.811-.151 2.588-.454l.334 1.48c-.908.396-1.98.593-3.217.593-1.488 0-2.656-.438-3.506-1.313-.848-.875-1.273-2.05-1.273-3.524 0-1.447.395-2.652 1.186-3.613.828-1.026 1.947-1.539 3.355-1.539 1.383 0 2.43.513 3.141 1.539.563.815.846 1.823.846 3.02zm-2.033-.553c.014-.632-.125-1.178-.414-1.639-.369-.593-.936-.889-1.699-.889-.697 0-1.264.289-1.697.869-.355.461-.566 1.014-.631 1.658h4.441z"/></g><g fill="#FFF"><path d="M49.05 10.009c0 1.177-.353 2.063-1.058 2.658-.653.549-1.581.824-2.783.824-.596 0-1.106-.026-1.533-.078V6.982c.557-.09 1.157-.136 1.805-.136 1.145 0 2.008.249 2.59.747.652.563.979 1.368.979 2.416zm-1.105.029c0-.763-.202-1.348-.606-1.756-.404-.407-.994-.611-1.771-.611-.33 0-.611.022-.844.068v4.889c.129.02.365.029.708.029.802 0 1.421-.223 1.857-.669s.656-1.096.656-1.95zM54.909 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.009.718-1.727.718-.692 0-1.243-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.712-.698c.692 0 1.248.229 1.669.688.4.446.601 1.022.601 1.726zm-1.087.034c0-.435-.094-.808-.281-1.119-.22-.376-.533-.564-.94-.564-.421 0-.741.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .714-.191.94-.574.194-.317.291-.693.291-1.128zM62.765 8.719l-1.475 4.714h-.96l-.611-2.047a15.32 15.32 0 0 1-.379-1.523h-.019a11.15 11.15 0 0 1-.379 1.523l-.649 2.047h-.971l-1.387-4.714h1.077l.533 2.241c.129.53.235 1.035.32 1.513h.019c.078-.394.207-.896.389-1.503l.669-2.25h.854l.641 2.202c.155.537.281 1.054.378 1.552h.029c.071-.485.178-1.002.32-1.552l.572-2.202h1.029zM68.198 13.433H67.15v-2.7c0-.832-.316-1.248-.95-1.248a.946.946 0 0 0-.757.343 1.217 1.217 0 0 0-.291.808v2.796h-1.048v-3.366c0-.414-.013-.863-.038-1.349h.921l.049.737h.029c.122-.229.304-.418.543-.569.284-.176.602-.265.95-.265.44 0 .806.142 1.097.427.362.349.543.87.543 1.562v2.824zM71.088 13.433h-1.047V6.556h1.047v6.877zM77.258 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.01.718-1.727.718-.693 0-1.244-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.711-.698c.693 0 1.248.229 1.67.688.4.446.601 1.022.601 1.726zm-1.088.034c0-.435-.094-.808-.281-1.119-.219-.376-.533-.564-.939-.564-.422 0-.742.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .713-.191.939-.574.195-.317.291-.693.291-1.128zM82.33 13.433h-.941l-.078-.543h-.029c-.322.433-.781.65-1.377.65-.445 0-.805-.143-1.076-.427a1.339 1.339 0 0 1-.369-.96c0-.576.24-1.015.723-1.319.482-.304 1.16-.453 2.033-.446V10.3c0-.621-.326-.931-.979-.931-.465 0-.875.117-1.229.349l-.213-.688c.438-.271.979-.407 1.617-.407 1.232 0 1.85.65 1.85 1.95v1.736c0 .471.023.846.068 1.124zm-1.088-1.62v-.727c-1.156-.02-1.734.297-1.734.95 0 .246.066.43.201.553a.733.733 0 0 0 .512.184c.23 0 .445-.073.641-.218a.893.893 0 0 0 .38-.742zM88.285 13.433h-.93l-.049-.757h-.029c-.297.576-.803.864-1.514.864-.568 0-1.041-.223-1.416-.669s-.562-1.025-.562-1.736c0-.763.203-1.381.611-1.853.395-.44.879-.66 1.455-.66.633 0 1.076.213 1.328.64h.02V6.556h1.049v5.607c0 .459.012.882.037 1.27zm-1.086-1.988v-.786a1.194 1.194 0 0 0-.408-.965 1.03 1.03 0 0 0-.701-.257c-.391 0-.697.155-.922.466-.223.311-.336.708-.336 1.193 0 .466.107.844.322 1.135.227.31.533.465.916.465.344 0 .619-.129.828-.388.202-.239.301-.527.301-.863zM97.248 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.008.718-1.727.718-.691 0-1.242-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.713-.698c.691 0 1.248.229 1.668.688.4.446.601 1.022.601 1.726zm-1.086.034c0-.435-.094-.808-.281-1.119-.221-.376-.533-.564-.941-.564-.42 0-.74.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .715-.191.941-.574.193-.317.291-.693.291-1.128zM102.883 13.433h-1.047v-2.7c0-.832-.316-1.248-.951-1.248-.311 0-.562.114-.756.343s-.291.499-.291.808v2.796h-1.049v-3.366c0-.414-.012-.863-.037-1.349h.92l.049.737h.029a1.53 1.53 0 0 1 .543-.569c.285-.176.602-.265.951-.265.439 0 .805.142 1.096.427.363.349.543.87.543 1.562v2.824zM109.936 9.504h-1.154v2.29c0 .582.205.873.611.873.188 0 .344-.016.467-.049l.027.795c-.207.078-.479.117-.814.117-.414 0-.736-.126-.969-.378-.234-.252-.35-.676-.35-1.271V9.504h-.689v-.785h.689v-.864l1.027-.31v1.173h1.154v.786zM115.484 13.433h-1.049v-2.68c0-.845-.316-1.268-.949-1.268-.486 0-.818.245-1 .735a1.317 1.317 0 0 0-.049.377v2.835h-1.047V6.556h1.047v2.841h.02c.33-.517.803-.775 1.416-.775.434 0 .793.142 1.078.427.355.355.533.883.533 1.581v2.803zM121.207 10.853c0 .188-.014.346-.039.475h-3.143c.014.466.164.821.455 1.067.266.22.609.33 1.029.33.465 0 .889-.074 1.271-.223l.164.728c-.447.194-.973.291-1.582.291-.73 0-1.305-.215-1.721-.645-.418-.43-.625-1.007-.625-1.731 0-.711.193-1.303.582-1.775.406-.504.955-.756 1.648-.756.678 0 1.193.252 1.541.756.281.4.42.895.42 1.483zm-1-.271a1.411 1.411 0 0 0-.203-.805c-.182-.291-.459-.437-.834-.437a.995.995 0 0 0-.834.427 1.586 1.586 0 0 0-.311.815h2.182z"/></g></svg>'};

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="58" height="26" viewBox="0 0 58 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.87 7.148c1.656 0 2.862.36 3.618 1.08.768.708 1.152 1.686 1.152 2.934 0 .744-.156 1.446-.468 2.106-.312.648-.834 1.17-1.566 1.566-.72.396-1.704.594-2.952.594h-1.17V20h-2.718V7.148h4.104zm-.144 2.232h-1.242v3.816h.9c.768 0 1.374-.15 1.818-.45.456-.312.684-.81.684-1.494 0-1.248-.72-1.872-2.16-1.872zm11.21.594c1.32 0 2.327.288 3.023.864.708.564 1.062 1.434 1.062 2.61V20H43.15l-.522-1.332h-.072c-.42.528-.864.912-1.332 1.152-.468.24-1.11.36-1.926.36-.876 0-1.602-.252-2.178-.756-.576-.516-.864-1.302-.864-2.358 0-1.044.366-1.812 1.098-2.304.732-.504 1.83-.78 3.294-.828l1.71-.054v-.432c0-.516-.138-.894-.414-1.134-.264-.24-.636-.36-1.116-.36-.48 0-.948.072-1.404.216-.456.132-.912.3-1.368.504l-.882-1.818a7.727 7.727 0 0 1 1.746-.648 8.584 8.584 0 0 1 2.016-.234zm1.421 5.472l-1.044.036c-.864.024-1.464.18-1.8.468-.336.288-.504.666-.504 1.134 0 .408.12.702.36.882.24.168.552.252.936.252.576 0 1.062-.168 1.458-.504.396-.348.594-.834.594-1.458v-.81zm4.056-5.274h2.934l1.854 5.526c.096.264.168.54.216.828.048.276.084.57.108.882h.054c.036-.312.084-.606.144-.882.072-.288.15-.564.234-.828l1.818-5.526h2.88L52.497 21.26c-.372 1.02-.918 1.782-1.638 2.286-.708.516-1.53.774-2.466.774-.3 0-.564-.018-.792-.054a5.864 5.864 0 0 1-.576-.09v-2.124c.132.024.288.048.468.072.192.024.39.036.594.036.564 0 1.008-.174 1.332-.522.336-.336.582-.744.738-1.224l.162-.486-3.906-9.756zM16.937 2.4c0 2.43-2.016 4.398-4.501 4.4 0-2.431 2.015-4.4 4.501-4.4zM16.608 12.6c0-1.56 1.152-2.885 2.76-3.384C18.35 7.98 16.87 7.2 15.218 7.2c-1.07 0-2.193.605-2.193.605-.324.175-.854.175-1.18 0 0 0-1.121-.605-2.191-.605-3.072 0-5.564 2.686-5.563 6 0 4.636 2.179 8.4 4.868 8.4 1.287 0 2.865-.728 2.865-.728.337-.156.888-.156 1.225 0 0 0 1.576.728 2.864.728 2.078 0 3.846-2.252 4.544-5.414-2.153-.142-3.849-1.692-3.849-3.586z" fill="#fff"/></svg>'};

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.006 5.882h9.17a.588.588 0 1 0 0-1.176h-9.17l3.117-3.118a.588.588 0 1 0-.835-.823L.171 4.882a.588.588 0 0 0 0 .824l4.117 4.118A.588.588 0 0 0 5.123 9L2.006 5.882z" fill="#232323"/></svg>'};

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="310" height="44" viewBox="0 0 310 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M43.197 12.62H1.734v17.125h41.463V12.619z" fill="#E6E6E6"/><path d="M4.438 36.956h36.055a2.704 2.704 0 0 0 2.704-2.704v-4.507H1.734v4.507a2.704 2.704 0 0 0 2.704 2.704z" fill="#E79800"/><path d="M40.493 6.31H4.438a2.704 2.704 0 0 0-2.704 2.704v4.506h41.463V9.014a2.704 2.704 0 0 0-2.704-2.704zM18.173 25.96h2.352l1.472-8.632h-2.353l-1.47 8.631zM26.74 20.794c-.821-.4-1.325-.666-1.32-1.07 0-.36.427-.743 1.348-.743a4.254 4.254 0 0 1 1.972.43l.319-1.871a6.073 6.073 0 0 0-2.108-.363c-2.325 0-3.963 1.171-3.976 2.849-.014 1.24 1.169 1.932 2.061 2.345.916.423 1.224.693 1.22 1.07-.006.58-.731.844-1.408.844-1.044 0-1.57-.162-2.518-.59L22 25.626c.55.24 1.566.45 2.622.46 2.473 0 4.078-1.157 4.096-2.949.007-.982-.62-1.729-1.977-2.344zM35.091 17.336h-1.818c-.563 0-.984.154-1.232.716l-3.494 7.91h2.47s.405-1.064.497-1.297l3.013.004c.07.301.286 1.293.286 1.293h2.183l-1.905-8.626zm-2.9 5.564c.097-.249 1.057-2.714 1.249-3.237.318 1.488.008.044.704 3.237H32.19zM16.2 17.334l-2.303 5.886-.246-1.196-.824-3.967c-.143-.546-.556-.71-1.067-.728H7.966l-.03.179a9.914 9.914 0 0 1 2.471.946l2.092 7.497 2.49-.003 3.704-8.615H16.2v.001z" fill="#1A1876"/><g clip-path="url(#a)"><path d="M93.672 6.31H57.618a2.704 2.704 0 0 0-2.704 2.704v25.238a2.704 2.704 0 0 0 2.704 2.704h36.054a2.704 2.704 0 0 0 2.704-2.704V9.014a2.704 2.704 0 0 0-2.704-2.704z" fill="#243747"/><path d="M71.138 28.843a7.21 7.21 0 1 0 0-14.421 7.21 7.21 0 0 0 0 14.421z" fill="#E61C24"/><path d="M80.093 28.843a7.21 7.21 0 1 0 0-14.421 7.21 7.21 0 0 0 0 14.421z" fill="#F99F1B"/><path d="M75.615 15.986a7.197 7.197 0 0 0 0 11.293 7.197 7.197 0 0 0 0-11.293z" fill="#F26622"/></g><path d="M149.558 21.459V9.014a2.704 2.704 0 0 0-2.704-2.704H110.8a2.704 2.704 0 0 0-2.704 2.704v25.238a2.704 2.704 0 0 0 2.704 2.704h9.544c14.098-1.973 25.612-9.83 29.214-15.497z" fill="#E6E6E6"/><path d="M149.558 34.252V21.459c-3.602 5.667-15.116 13.524-29.214 15.497h26.51a2.704 2.704 0 0 0 2.704-2.704z" fill="#E6E6E6"/><path d="M149.558 34.252V21.459c-3.602 5.667-15.116 13.524-29.214 15.497h26.51a2.704 2.704 0 0 0 2.704-2.704zM129.755 18.94c-1.524 0-2.76 1.19-2.76 2.66 0 1.563 1.182 2.73 2.76 2.73 1.539 0 2.752-1.184 2.752-2.7.001-1.507-1.204-2.69-2.752-2.69z" fill="#FA7000"/><path d="M114.086 19.038h-1.484v5.176h1.475c.785 0 1.351-.186 1.848-.598.589-.488.94-1.225.94-1.989-.001-1.528-1.142-2.59-2.779-2.59zm1.181 3.887c-.321.287-.73.412-1.384.412h-.27v-3.423h.271c.654 0 1.047.117 1.384.418.347.31.556.791.556 1.288-.001.498-.209.996-.557 1.305zM118.336 19.038h-1.006v5.176h1.006v-5.176zM120.807 21.022c-.608-.223-.785-.372-.785-.651 0-.326.317-.572.753-.572.302 0 .552.12.817.416l.525-.689a2.25 2.25 0 0 0-1.519-.575c-.916 0-1.615.637-1.615 1.48 0 .716.325 1.08 1.272 1.424.396.137.597.231.7.295.202.13.302.317.302.534 0 .42-.334.73-.786.73-.48 0-.868-.24-1.101-.692l-.651.631c.465.682 1.023.986 1.792.986 1.048 0 1.787-.7 1.787-1.7.001-.824-.342-1.197-1.491-1.617zM122.615 21.627c0 1.523 1.195 2.703 2.732 2.703.434 0 .806-.086 1.264-.302v-1.19c-.405.406-.76.567-1.219.567-1.017 0-1.737-.736-1.737-1.785 0-.991.743-1.777 1.692-1.777.478 0 .844.169 1.263.582v-1.188c-.442-.224-.806-.316-1.243-.316-1.528 0-2.752 1.202-2.752 2.706zM134.791 22.513l-1.38-3.475h-1.101l2.195 5.307h.541l2.238-5.307h-1.093l-1.4 3.475zM137.742 24.214h2.862v-.877h-1.852V21.94h1.782v-.877h-1.782v-1.15h1.852v-.875h-2.862v5.176zM144.601 20.564c0-.97-.665-1.527-1.831-1.527h-1.499v5.176h1.012v-2.081h.131l1.395 2.081h1.243l-1.629-2.182c.761-.154 1.178-.674 1.178-1.466zm-2.024.854h-.293v-1.566h.309c.631 0 .969.265.969.77 0 .517-.338.796-.985.796z" fill="#444"/><path d="M200.034 6.31h-36.055a2.704 2.704 0 0 0-2.704 2.704v25.238a2.704 2.704 0 0 0 2.704 2.704h36.055a2.704 2.704 0 0 0 2.704-2.704V9.014a2.704 2.704 0 0 0-2.704-2.704z" fill="#E6E6E6"/><path d="M176.598 18.027h-7.211v8.113h7.211v-8.113zM185.612 18.027h-7.211v8.113h7.211v-8.113zM194.625 18.027h-7.21v8.113h7.21v-8.113z" fill="#fff"/><path d="M188.884 21.998h1.696c.484 0 .762.26.841.607a.791.791 0 0 1 0 .37c-.08.354-.373.608-.812.608h-1.725v-1.585zm2.334-1.794a.768.768 0 0 1 0 .337c-.09.41-.417.563-.841.563h-1.493V19.64h1.522c.478 0 .739.231.812.563zm3.407-7.585v15.323a2.704 2.704 0 0 1-2.704 2.704h-4.506v-6.125h4.673c1.016-.008 1.897-.524 1.897-1.501 0-.065-.004-.127-.012-.189-.102-.733-.795-1.191-1.709-1.261v-.036c.912-.141 1.368-.723 1.368-1.379 0-.48-.224-.87-.645-1.12-.505-.298-1.076-.291-1.595-.291h-3.977v-3.42a2.704 2.704 0 0 1 2.704-2.705h4.506z" fill="#269732"/><path d="M169.387 23.044v-7.72a2.704 2.704 0 0 1 2.705-2.705h4.506v15.323a2.7 2.7 0 0 1-2.7 2.704h-4.511v-6.332c1.097.302 3.747.638 5.302.047.98-.37 1.491-1.07 1.491-2.13v-3.486h-2.584v3.485c0 .704-.388 1.247-1.078 1.424-.891.23-2.197-.158-3.131-.61z" fill="#034D9B"/><path d="M178.401 19.558v-4.235a2.704 2.704 0 0 1 2.704-2.704h4.507v15.323a2.703 2.703 0 0 1-2.702 2.704h-4.509V23.71c.719.617 1.732.85 2.667.939 1.207.106 2.513.012 3.909-.333v-1.27c-.816.405-1.831.77-2.982.654-1.264-.146-1.894-.937-1.894-2.065 0-1.188.699-1.947 1.923-2.07.981-.098 2.03.195 2.953.658V18.95a12.117 12.117 0 0 0-3.474-.36c-1.078.052-2.285.267-3.102.968z" fill="#AD1031"/><path d="M253.213 6.31h-36.054a2.704 2.704 0 0 0-2.704 2.704v25.238a2.704 2.704 0 0 0 2.704 2.704h36.054a2.704 2.704 0 0 0 2.704-2.704V9.014a2.704 2.704 0 0 0-2.704-2.704z" fill="#0082CF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M234.783 19.148h-1.617v7.907h1.617v-7.907zM236.266 19.16v1.483h1.361v4.46c0 .616.169 1.11.494 1.484.325.385.759.576 1.305.59.542.012 1.023-.11 1.43-.36l.026-.013v-.026l.386-1.505-.095.06c-.434.265-.832.396-1.197.396-.503 0-.759-.3-.759-.89v-4.196h1.651V19.16h-1.651V16.69l-1.591.854v1.617h-1.36zM244.09 19.148h-1.629v7.907h1.629v-7.907zM232.238 20.392l-.035-.027c-.745-.905-1.677-1.348-2.796-1.348-1.171 0-2.132.36-2.905 1.07-.819.75-1.231 1.761-1.231 3.028 0 1.265.412 2.267 1.231 3.025.759.712 1.734 1.062 2.905 1.062 1.119 0 2.06-.446 2.796-1.34l.035-.025-.915-1.105-.035.034c-.594.59-1.231.893-1.916.893-.715 0-1.305-.242-1.773-.724-.472-.472-.697-1.083-.697-1.82 0-.738.225-1.353.697-1.835.468-.468 1.058-.71 1.773-.71.685 0 1.322.303 1.916.892l.035.035.915-1.105z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M233.964 17.847a6.733 6.733 0 0 1 2.158-1.495 6.182 6.182 0 0 1 2.472-.503c.854 0 1.686.165 2.484.503a6.884 6.884 0 0 1 2.142 1.495l.026.022h1.855l-.07-.109a7.945 7.945 0 0 0-2.835-2.453 7.674 7.674 0 0 0-3.602-.885c-1.253 0-2.463.29-3.607.884a7.91 7.91 0 0 0-2.832 2.454l-.073.108h1.868l.014-.021z" fill="#ED2B9F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M234.783 19.148h-1.617v7.907h1.617v-7.907zM236.266 19.16v1.483h1.361v4.46c0 .616.169 1.11.494 1.484.325.385.759.576 1.305.59.542.012 1.023-.11 1.43-.36l.026-.013v-.026l.386-1.505-.095.06c-.434.265-.832.396-1.197.396-.503 0-.759-.3-.759-.89v-4.196h1.651V19.16h-1.651V16.69l-1.591.854v1.617h-1.36zM244.09 19.148h-1.629v7.907h1.629v-7.907zM232.238 20.392l-.035-.027c-.745-.905-1.677-1.348-2.796-1.348-1.171 0-2.132.36-2.905 1.07-.819.75-1.231 1.761-1.231 3.028 0 1.265.412 2.267 1.231 3.025.759.712 1.734 1.062 2.905 1.062 1.119 0 2.06-.446 2.796-1.34l.035-.025-.915-1.105-.035.034c-.594.59-1.231.893-1.916.893-.715 0-1.305-.242-1.773-.724-.472-.472-.697-1.083-.697-1.82 0-.738.225-1.353.697-1.835.468-.468 1.058-.71 1.773-.71.685 0 1.322.303 1.916.892l.035.035.915-1.105z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M233.964 17.847a6.733 6.733 0 0 1 2.158-1.495 6.182 6.182 0 0 1 2.472-.503c.854 0 1.686.165 2.484.503a6.884 6.884 0 0 1 2.142 1.495l.026.022h1.855l-.07-.109a7.945 7.945 0 0 0-2.835-2.453 7.674 7.674 0 0 0-3.602-.885c-1.253 0-2.463.29-3.607.884a7.91 7.91 0 0 0-2.832 2.454l-.073.108h1.868l.014-.021z" fill="#FF2400"/><path d="M306.395 6.31H270.34a2.704 2.704 0 0 0-2.704 2.704v25.238a2.704 2.704 0 0 0 2.704 2.704h36.055a2.704 2.704 0 0 0 2.704-2.704V9.014a2.704 2.704 0 0 0-2.704-2.704z" fill="#007AC6"/><path d="M276.229 22.02h2.1l-1.05-2.576-1.05 2.575zm29.264-4.894h-5.38l-1.312 1.416-1.182-1.416h-11.417l-1.05 2.317-1.05-2.317h-4.593v1.03l-.525-1.03h-3.937l-3.805 9.014h4.593l.525-1.417h1.312l.525 1.417h5.118v-1.03l.393 1.03h2.625l.394-1.16v1.16h10.499l1.312-1.417 1.181 1.417h5.38l-3.411-4.507 3.805-4.507zm-15.879 7.725h-1.444V19.83l-2.231 5.021h-1.312l-2.231-5.021v5.021h-3.019l-.524-1.416h-3.15l-.524 1.416h-1.706l2.755-6.438h2.231l2.493 6.052v-6.052h2.493l1.969 4.378 1.837-4.378h2.493v6.438h-.13zm12.992 0h-1.968l-1.707-2.189-1.968 2.19h-5.906v-6.439h6.037l1.837 2.06 1.968-2.06h1.837l-2.886 3.22 2.756 3.218zm-10.105-5.15v1.16h3.281v1.287h-3.281v1.287h3.675l1.706-1.931-1.574-1.803h-3.807z" fill="#fff"/><defs><clipPath id="a"><path fill="#fff" transform="translate(54.013)" d="M0 0h43.265v43.265H0z"/></clipPath></defs></svg>'};

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="187" height="166" viewBox="0 0 187 166" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M48.334 63.128c.037-.188.037-.376.037-.527 0-.15 0-.376-.038-.527v-.113c-.301-2.485-2.45-4.443-5.014-4.443-2.79 0-5.09 2.26-5.09 5.083V97.843a5.075 5.075 0 0 0 5.053 4.781c2.79 0 5.09-2.259 5.09-5.082 0-.189 0-.377-.038-.528V63.128zM17.23 68.7C7.993 68.7.528 76.08.34 85.23v.338a5.049 5.049 0 0 0 5.051 5.046c2.79 0 5.052-2.26 5.052-5.046v-.263c.151-3.615 3.13-6.514 6.787-6.514s6.635 2.9 6.786 6.514c.113-2.673 2.338-4.82 5.052-4.82a5.05 5.05 0 0 1 5.052 4.782c-.188-9.187-7.691-16.566-16.89-16.566z" fill="#F69880"/><path d="M34.12 85.418a5.049 5.049 0 0 0-5.052-5.046 5.049 5.049 0 0 0-5.052 5.046v.226c-.075 3.652-3.092 6.626-6.786 6.626-3.733 0-6.787-3.05-6.787-6.777-.037 2.749-2.262 5.008-5.052 5.008-2.79 0-5.014-2.222-5.052-5.008 0 9.338 7.578 16.868 16.89 16.868 9.275 0 16.816-7.455 16.891-16.717v-.226z" fill="#F0532C"/><g opacity=".5"><path opacity=".3" fill="url(#a)" d="M111.158 80.289h6.877v7.229h-6.877z"/></g><g opacity=".5"><path opacity=".3" fill="url(#b)" d="M147.045 80.321h6.877v7.139h-6.877z"/></g><path d="M72.086 97.504l-.038-12.049c0-9.337-7.578-16.905-16.928-16.905-9.35 0-16.928 7.568-16.928 16.905v.076-.076a5.09 5.09 0 0 0 5.09 5.083 5.054 5.054 0 0 0 5.052-4.63v-.49a6.762 6.762 0 0 1 6.786-6.702c3.582 0 6.522 2.786 6.786 6.288l.076 12.35v.526a5.064 5.064 0 0 0 5.052 4.707c2.79-.038 5.052-2.297 5.052-5.083z" fill="#F0532C"/><path d="M93.048 68.475c-8.747 0-15.948 6.626-16.853 15.098-.038.226-.075.49-.075.715a5.09 5.09 0 0 0 5.09 5.083c2.714 0 4.938-2.146 5.051-4.82.453-3.35 3.318-5.948 6.787-5.948a6.779 6.779 0 0 1 6.786 6.664v12.35a5.09 5.09 0 0 0 5.09 5.083 5.065 5.065 0 0 0 5.089-5.083l-.037-12.35c-.076-9.3-7.616-16.792-16.928-16.792z" fill="#F69880"/><path d="M92.934 92.534s-2.94.188-5.09-2.26c-1.847-2.108-1.771-4.404-1.696-5.007v-.15c0-.151.038-.264.038-.415a5.09 5.09 0 0 0-5.09-5.082 5.064 5.064 0 0 0-5.052 4.706s-1.093 7.154 4.788 13.29c5.128 5.423 12.103 5.084 12.103 5.084 2.79 0 5.09-2.259 5.09-5.083a5.065 5.065 0 0 0-5.09-5.083z" fill="#F0532C"/><path d="M186.774 85.267c-.076-9.3-7.616-16.792-16.928-16.792-8.747 0-15.948 6.626-16.853 15.098a4.57 4.57 0 0 0-.075.715 5.089 5.089 0 0 0 5.089 5.083c2.715 0 4.939-2.146 5.052-4.82h.038a6.801 6.801 0 0 1 6.749-5.948 6.779 6.779 0 0 1 6.786 6.664v12.35a5.09 5.09 0 0 0 5.09 5.083c2.79 0 5.089-2.259 5.089-5.083l-.037-12.35z" fill="#F69880"/><path d="M169.733 92.534s-2.941.188-5.09-2.26c-1.847-2.108-1.772-4.404-1.697-5.007v-.15c0-.151.038-.264.038-.415a5.09 5.09 0 0 0-5.09-5.082 5.065 5.065 0 0 0-5.052 4.706s-1.093 7.154 4.789 13.29c5.127 5.423 12.102 5.084 12.102 5.084 2.79 0 5.089-2.259 5.089-5.083-.037-2.824-2.299-5.083-5.089-5.083z" fill="#F0532C"/><path d="M149.449 85.832v-.301c0-9.413-7.653-17.056-17.079-17.056-8.784 0-16.023 6.626-16.965 15.173a4.722 4.722 0 0 0-.113 1.054 5.129 5.129 0 0 0 5.127 5.121c2.752 0 5.014-2.184 5.127-4.895a6.88 6.88 0 0 1 6.862-6.212c3.77 0 6.862 3.05 6.862 6.852 0 .189 0 .415-.038.603l.038 11.333c0 2.824 2.3 5.12 5.127 5.12a5.13 5.13 0 0 0 5.128-5.12l-.076-11.672z" fill="#F69880"/><path d="M125.509 84.74v-.339a5.119 5.119 0 0 0-5.128-4.781 5.13 5.13 0 0 0-5.127 5.12v12.802a5.13 5.13 0 0 0 5.127 5.12 5.13 5.13 0 0 0 5.128-5.12V84.74z" fill="#F0532C"/><defs><pattern id="a" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#c" transform="scale(.01205 .01136)"/></pattern><pattern id="b" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#d" transform="scale(.01266 .01205)"/></pattern><image id="c" width="83" height="88" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABYCAYAAACJdcvDAAAABGdBTUEAALGPC/xhBQAAAYRpQ0NQSUNDIFByb2ZpbGUAACiRlZE/SMNAFMa/VKRL/TMUERcDSqcqtYIoiNB2EKFDLR1UdEjT9A/UJKRnVXQUdCw4iC6KXRycdS246qQogri4uBddtMR3uWoUUfGD8H559+7eu+8Az5FimkVPJ7CoMys5GZVnZudk7wO86IUjRS2ZkUQizvk9ftXzNSQeLwf4Wd/Xf5Uvo5VUQPITM9W0GPEWcd8yMzkfE/stGoq4xjkn+IpzWvCjU5NKxohfidvLao72enzEIT1T0InHiSfUvJIhXicOpj/V5z6xmMdRT0wpFtKWwrSMzK2JGUXDKpmKqv3zkn+JaSuMx5hhrlqFXJ7JEXJSk6d0dTAoh0NDYwB/F1Fdn3b8lrrO3ZxxAIw+AS0VN5feAU43ge5bN9e/D3RsACdn6pJVbraXQN2FZ81/6YPwEwtfHY0A1RsgtQbEL4DdPSCQpT7zQKKN8jQ9W3A/oVJ2OCzO8kWB1nvbrgcA7zbQqNj2y6FtN6p0nzugpr8BSn9vpMdJGpoAAAAJcEhZcwAALiMAAC4jAXilP3YAAAFzSURBVHgB7dXrasMwDAbQbu//zt38w2BK11xkyWacQInb1Eg6/iCPh4sAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQL/Q+Drd4z22f7atcmjvp47yh41Xd3z1X62Qr3afBZutI8tUKNDRHFn11+KOnuYK7hZtZeBZg10hJpddwno99HUnp8XyE7Iu06qapanUzLfHffN36pS0turrleaTsnsxzzhXpmUylojTVk6JXNkD65hBgHH7TBHjeAaZhBw3A5z1Aiuq9+w1fXK3uTtHCQzmMZxe3VSWu2qmqWpbINJZlOYdFWl5LXd7LrlqWwDSubrMQe+ZyfkU2tZtZeksg2aNdAnxPHZ7PrLIHfAnNnDUsiZg4xpu7u+m9LliH3guwP0/Rn3sz1tg9gRzjbe/195/6u37RArUdQiQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQI5Aj+DqxIrMdeOeQAAAABJRU5ErkJggg=="/><image id="d" width="79" height="83" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABTCAYAAADeIFpmAAAABGdBTUEAALGPC/xhBQAAAYRpQ0NQSUNDIFByb2ZpbGUAACiRlZE/SMNAFMa/VKRL/TMUERcDSqcqtYIoiNB2EKFDLR1UdEjT9A/UJKRnVXQUdCw4iC6KXRycdS246qQogri4uBddtMR3uWoUUfGD8H559+7eu+8Az5FimkVPJ7CoMys5GZVnZudk7wO86IUjRS2ZkUQizvk9ftXzNSQeLwf4Wd/Xf5Uvo5VUQPITM9W0GPEWcd8yMzkfE/stGoq4xjkn+IpzWvCjU5NKxohfidvLao72enzEIT1T0InHiSfUvJIhXicOpj/V5z6xmMdRT0wpFtKWwrSMzK2JGUXDKpmKqv3zkn+JaSuMx5hhrlqFXJ7JEXJSk6d0dTAoh0NDYwB/F1Fdn3b8lrrO3ZxxAIw+AS0VN5feAU43ge5bN9e/D3RsACdn6pJVbraXQN2FZ81/6YPwEwtfHY0A1RsgtQbEL4DdPSCQpT7zQKKN8jQ9W3A/oVJ2OCzO8kWB1nvbrgcA7zbQqNj2y6FtN6p0nzugpr8BSn9vpMdJGpoAAAAJcEhZcwAALgoAAC4jAVgGa4gAAAFVSURBVHgB7dJBEsIgDAVQ9f531umiM7RaBEmExXNTi0iSx7/dfAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIFogXv0gQHnlT09A85LO6JsNK1I48G1XpZErDXcOPPwtp4elkLsaXxY6XTASO0lEEcGOFl0vUbUnQ746BrZ5oNARAIOBza8RNacmj7Ja7jtqy2RKbiqUa5n1JuWPskrr7bze0YSrlrIrDUlfZJ3ddUN65lp+FQ+o96U1G3DSd6nK25cy0jCt9KRNaelbhtS8r5ddeX3yBRUyrz9FFF3auq2iSTv7V7bFyIS0F7tuHOk9vTUbaOMDHCk+P2tp4cl0PZRexrf/5P1rPWyFNoOUGt43/PvZ9nTkmj/BlGPAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEBgRcvIg8eTvQJZwAAAABJRU5ErkJggg=="/></defs></svg>'};

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="66" height="18" viewBox="0 0 66 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.357 0h-5.113a.708.708 0 0 0-.701.592l-2.067 12.965a.423.423 0 0 0 .422.487h2.624a.497.497 0 0 0 .49-.415l.587-3.676a.708.708 0 0 1 .701-.593h1.618c3.367 0 5.312-1.612 5.82-4.806.228-1.398.009-2.496-.652-3.263C47.357.448 46.068 0 44.356 0zm.59 4.736c-.28 1.815-1.682 1.815-3.037 1.815h-.77l.54-3.39a.426.426 0 0 1 .422-.355c1.123 0 2.109-.045 2.598.52.269.312.349.773.247 1.41zM7.886 0H2.773a.708.708 0 0 0-.7.592L.004 13.557a.423.423 0 0 0 .422.487h2.441a.708.708 0 0 0 .702-.592l.558-3.498a.708.708 0 0 1 .701-.592h1.618c3.367 0 5.312-1.612 5.82-4.806.228-1.398.009-2.496-.652-3.263C10.885.448 9.597 0 7.886 0zm.59 4.736c-.28 1.815-1.682 1.815-3.037 1.815h-.772l.54-3.39a.426.426 0 0 1 .422-.355h.355c.922 0 1.794 0 2.244.52.268.312.35.773.248 1.41zM23.17 4.678h-2.448a.426.426 0 0 0-.422.356l-.108.677c-.237-.341-.71-1.26-3.064-1.26-2.704 0-5.016 2.027-5.465 4.87-.234 1.417.099 2.773.911 3.719.747.868 1.813 1.231 3.084 1.231 2.18 0 3.39-1.385 3.39-1.385l-.11.674a.423.423 0 0 0 .422.487h2.205a.708.708 0 0 0 .702-.592l1.323-8.288a.424.424 0 0 0-.42-.489zM19.759 9.39c-.236 1.383-1.348 2.31-2.763 2.31-.71 0-1.278-.225-1.644-.653-.361-.424-.498-1.027-.383-1.7.221-1.371 1.35-2.33 2.744-2.33.696 0 1.26.228 1.633.66.373.434.52 1.043.413 1.713zM59.64 4.678h-2.449a.426.426 0 0 0-.421.356l-.108.677c-.237-.341-.71-1.26-3.064-1.26-2.704 0-5.016 2.027-5.465 4.87-.234 1.417.098 2.773.91 3.719.748.868 1.814 1.231 3.085 1.231 2.18 0 3.39-1.385 3.39-1.385l-.11.674a.423.423 0 0 0 .421.487h2.206a.708.708 0 0 0 .701-.592l1.324-8.288a.423.423 0 0 0-.42-.489zM56.227 9.39c-.237 1.383-1.347 2.31-2.762 2.31-.71 0-1.279-.225-1.644-.653-.361-.424-.498-1.027-.383-1.7.22-1.371 1.35-2.33 2.744-2.33.696 0 1.26.228 1.633.66.372.434.52 1.043.412 1.713zM36.21 4.678h-2.462a.714.714 0 0 0-.588.309L29.765 9.93 28.326 5.18a.71.71 0 0 0-.68-.502h-2.42a.422.422 0 0 0-.404.558l2.71 7.865-2.55 3.557a.42.42 0 0 0 .348.665h2.458a.717.717 0 0 0 .584-.302l8.184-11.68a.42.42 0 0 0-.347-.663zM62.524.357L60.426 13.56a.423.423 0 0 0 .422.488h2.11a.708.708 0 0 0 .702-.593L65.729.491a.423.423 0 0 0-.422-.488h-2.363a.42.42 0 0 0-.42.354z" fill="#fff"/></svg>'};

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="155" height="155" viewBox="0 0 155 155" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M61.324 17.13C28.309 25.976 8.687 59.474 16.767 92.322l.324 1.21c2.666 9.948 12.912 15.847 22.884 13.175 9.972-2.671 15.896-12.904 13.23-22.852l-.252-.941c-2.919-13.05 4.953-26.254 18.025-29.756 13.07-3.503 26.49 3.996 30.487 16.757-2.153-9.653 3.744-19.446 13.447-22.046 9.702-2.6 19.535 2.835 22.632 12.235-9.463-32.621-43.34-51.785-76.22-42.974z" fill="#F69880"/><path d="M137.693 60.662c-2.689-10.036-12.955-16.007-22.927-13.335-9.972 2.672-15.877 12.976-13.187 23.012l.218.814c3.255 13.228-4.654 26.831-17.86 30.37-13.34 3.574-27.2-4.487-30.797-17.914 2.518 9.937-3.252 20.205-13.224 22.877-9.972 2.672-20.067-3.2-22.89-13.2 9.012 33.635 43.366 53.503 76.65 44.585 33.15-8.883 52.906-42.959 44.235-76.395l-.218-.814z" fill="#F0532C"/></svg>'};

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(222);
module.exports = __webpack_require__(221);


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storage", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersCollection", function() { return usersCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contactsCollection", function() { return contactsCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messagesCollection", function() { return messagesCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numToUidCollection", function() { return numToUidCollection; });
var firebase = __webpack_require__(511);
// require('firebase/firestore');
__webpack_require__(513);
__webpack_require__(512);
__webpack_require__(514);

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyAikMRGtveNFKlmSUJ4yIsXw9_XloqvfvQ",
    authDomain: "ohana-4dd34.firebaseapp.com",
    databaseURL: "https://ohana-4dd34.firebaseio.com",
    projectId: "ohana-4dd34",
    storageBucket: "ohana-4dd34.appspot.com",
    messagingSenderId: "373526819310",
    appId: "1:373526819310:web:bab4999e026db50fb11eff"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// firebase utils
// const db = firebase.firestore()
var db = firebase.database();
var auth = firebase.auth();
var storage = firebase.storage();
// const currentUser = auth.currentUser

// firebase collections
var usersCollection = db.ref('Users/');
var contactsCollection = db.ref('Contacts/');
var messagesCollection = db.ref('Messages/');
var numToUidCollection = db.ref('NumberToUid/');



/***/ }),

/***/ 65:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 5.32l3.866 3.926 7.057-7.166-.943-.957-6.114 6.209-2.872-2.917L1 5.32z" fill="#fff" stroke="#fff"/></svg>'};

/***/ })

},[561]);


// WEBPACK FOOTER //
// static/js/app.js